import LinearScaleIcon from '@mui/icons-material/LinearScale';
import PauseIcon from '@mui/icons-material/Pause';
import UpdateIcon from '@mui/icons-material/Update';
import { Fab, Paper, Tooltip } from '@mui/material';
import { useSnackbar } from 'notistack';
import React, { forwardRef, useCallback, useContext, useEffect, useMemo, useRef, useState } from 'react';
import { MdLabel, MdLabelOff } from 'react-icons/md';
import ReactFlow, {
  Background,
  ControlButton,
  Controls,
  ReactFlowProvider,
  addEdge,
  applyEdgeChanges,
  applyNodeChanges,
  updateEdge,
  useEdgesState,
  useNodesState,
} from 'reactflow';
import 'reactflow/dist/style.css';
import './flowbuilderpannel.css';

import RefreshIcon from '@mui/icons-material/Refresh';
import NodesSection from './NodesSection';
// import FlowBuilderTop from '../FlowBuilderTop';
import { createDataProcessorApi, getNodeStatus } from "../../api's/DataProcessorApi";
import { getNodeStatusByExecutionId, getWorkflowExecutionByExecutionId } from "../../api's/ExecutionApi";
import { AWS_CONFIG_TYPE } from '../../BaseUrl';
import { AuthContext } from '../../context/AuthProvider';
import { WorkflowContext } from '../../contexts/WorkflowProvider';
import {
  DATA_QUALITY_RULES,
  DATA_QUALITY_RULES2,
  DATA_QUALITY_AGENT,
  DATA_QUALITY_REPORT,
  FETCH_SCHEMA,
  LLM_DQ_RULES,
  LLM_DQ_RULES_2,
  LLM_MAPPER,
  LLM_MAPPER_V2,
  PE_DATA_REPORT,
  PE_INSIGHTS_MAPPER,
  DEDUPLICATION_AGENT,
} from '../../utils/NodeModalContants';
import ButtonEdge from './ButtonEdge';
import CustomNode from './CustomNode';
import DataLineageGraph from './data-lineage/DataLineageGraph';
import NodeModalAggregate from './flow-builder-form/NodeModal_Aggregate';
import NodeModalC360 from './flow-builder-form/NodeModal_C360';
import NodeModalCluster from './flow-builder-form/NodeModal_Cluster';
import NodeModalCoalease from './flow-builder-form/NodeModal_Coalease';
import NodeModalDatabase from './flow-builder-form/NodeModal_Database';
import NodeModalDataCleansing from './flow-builder-form/NodeModal_DataCleansing';
import NodeModalDataProfiling from './flow-builder-form/NodeModal_DataProfiling';
import NodeModalDataQualityIssues from './flow-builder-form/NodeModal_DataQualityIssues';
import NodeModalDataQualityIssues2 from './flow-builder-form/NodeModal_DataQualityIssues2';
import NodeModalDatatypeConv from './flow-builder-form/NodeModal_DatatypeConv';
import NodeModalDataValidation from './flow-builder-form/NodeModal_DataValidation';
import NodeModalDateTime from './flow-builder-form/NodeModal_DateTime';
import NodeModalDrop from './flow-builder-form/NodeModal_Drop';
import NodeModalEmail from './flow-builder-form/NodeModal_Email';
import NodeModalExecuteSql from './flow-builder-form/NodeModal_ExecuteSQL';
import NodeModalFlatUnion from './flow-builder-form/NodeModal_FlatUnion';
import NodeModalHandleNull from './flow-builder-form/NodeModal_HandleNull';
import NodeModalImbalancedData from './flow-builder-form/NodeModal_ImbalancedData';
import NodeModalIngestionWrite from './flow-builder-form/NodeModal_IngestionWrite';
import NodeModalJoin from './flow-builder-form/NodeModal_Join';
import NodeModalKPI from './flow-builder-form/NodeModal_KPI';
import NodeModalLabelEncoder from './flow-builder-form/NodeModal_LabelEncoder';
import NodeModalLLMDQRules from './flow-builder-form/NodeModal_LLMDQRules';
import NodeModalLLMDQRules2 from './flow-builder-form/NodeModal_LLMDQRules2';
import NodeModalMathTransformation from './flow-builder-form/NodeModal_MathTransformation';
import NodeModalOneHotEncoder from './flow-builder-form/NodeModal_OneHotEncoder';
import NodeModalOpenSearch from './flow-builder-form/NodeModal_OpenSearch';
import NodeModalOutlier from './flow-builder-form/NodeModal_Outlier';
import NodeModalProfiling from './flow-builder-form/NodeModal_Profiling';
import NodeModalReadRealTime from './flow-builder-form/NodeModal_ReadRealTime';
import NodeModalResample from './flow-builder-form/NodeModal_Resample';
import NodeModalRFM from './flow-builder-form/NodeModal_RFM';
import NodeModalScaler from './flow-builder-form/NodeModal_Scaler';
import NodeModalSnowFlake from './flow-builder-form/NodeModal_SnowFlake';
import NodeModalSource from './flow-builder-form/NodeModal_Source';
import NodeModalUdf from './flow-builder-form/NodeModal_Udf';
import NodeModalUnion from './flow-builder-form/NodeModal_Union';
import NodeModalVisualInsights from './flow-builder-form/NodeModal_VisualInsights';
import NodeModalWrite from './flow-builder-form/NodeModal_Write';
import NodeModalWriteSFTP from './flow-builder-form/NodeModal_WriteSFTP';
import NodeModalAnalysis from './flow-builder-form/NodeModalAnalysis';
import NodeModalAutomaticRuleGenerator from './flow-builder-form/NodeModalAutomaticRuleGenerator';
import NodeModalCustomerSegmentation from './flow-builder-form/NodeModalCustomerSegmentation';
import NodeModalDataQualityRules from './flow-builder-form/NodeModalDataQualityRules';
import NodeModalDataQualityRules2 from './flow-builder-form/NodeModalDataQualityRules2';
import NodeModalFuzzyMatch from './flow-builder-form/NodeModalFuzzyMatch';
import NodeModalImbalancedDataSampling from './flow-builder-form/NodeModalImbalancedDataSampling';
import NodeModalLlmMapper from './flow-builder-form/NodeModalLlmMapper';
import NodeModalManualMerge from './flow-builder-form/NodeModalManualMerge';
import NodeModalPdfDataExtractor from './flow-builder-form/NodeModalPdfDataExtractor';
import NodeModalPEDataReport from './flow-builder-form/NodeModalPEDataReport';
import NodeModalPEInsightsMapper from './flow-builder-form/NodeModalPEInsightsMapper';
import NodeModalPlot from './flow-builder-form/NodeModalPlot';
import NodeModalRuleEngine from './flow-builder-form/NodeModalRuleEngine';
import NodeModalSegmentation from './flow-builder-form/NodeModalSegmentation';
import NodeModalVisualization from './flow-builder-form/NodeModalVisualization';
import NodeModalAddColumn from './flow-builder-form/NodeModal_AddColumn';
import NodeModalSwapColumn from './flow-builder-form/NodeModal_SwapColumn';
import NodeModalCountBlock from './flow-builder-form/NodeModal_CountBlock';
import NodeModalDuplicacyCheck from './flow-builder-form/NodeModal_DuplicacyCheck';
import NodeModalStatisticalAggregation from './flow-builder-form/NodeModal_StatisticalAggregation';
import NodeModalReadCSVAws from './flow-builder-form/read/NodeModalReadCsvAws';
import NodeModalReadCSVAzure from './flow-builder-form/read/NodeModalReadCSVAzure';
import NodeModalWriteAzure from './flow-builder-form/NodeModal_WriteAzure';
import NodeModalWriteCsvAWS from './flow-builder-form/NodeModal_WriteCsvAWS';
import NodeModalReadPostgres2 from './flow-builder-form/read/NodeModalReadPostgres2';
import NodeModalWritePostgres from './flow-builder-form/write/NodeModal_WritePostgres';
import NodeModalReadSnowflake2 from './flow-builder-form/read/NodeModalReadSnowflake2';
import NodeModalWriteSnowflake from './flow-builder-form/write/NodeModal_WriteSnowflake';
import NodeModalReadOracleDB from './flow-builder-form/read/NodeModalReadOracleDB';
import NodeModalWriteOracleDB from './flow-builder-form/write/NodeModal_WriteOracleDB';
import NodeModalReadSQLServer from './flow-builder-form/read/NodeModalReadSQLServer';
import NodeModalWriteSqlServer from './flow-builder-form/write/NodeModal_WriteSqlServer';
import NodeModalDeleteColumn from './flow-builder-form/NodeModal_DeleteColumn';
import NodePropertiesFilter from './flow-builder-form/NodeProperties_Filter';
import NodePropertiesPrediction from './flow-builder-form/NodeProperties_Prediction';
import NodePropertiesSort from './flow-builder-form/NodeProperties_Sort';
import NodePropertiesTraining from './flow-builder-form/NodeProperties_Training';
import NodeModalReadAPI from './flow-builder-form/read/NodeModal_API';
import NodeModalCopyDoc from './flow-builder-form/read/NodeModalCopyDoc';
import NodeModalFetchSchema from './flow-builder-form/read/NodeModalFetchSchema';
import NodeModalFileUploader from './flow-builder-form/read/NodeModalFileUploader';
import NodeModalReadAuroraDB from './flow-builder-form/read/NodeModalReadAuroraDB';
import NodeModalReadCosmos from './flow-builder-form/read/NodeModalReadCosmos';
import NodeModalReadCSV from './flow-builder-form/read/NodeModalReadCSV';
import NodeModalReadCSVData from './flow-builder-form/read/NodeModalReadCSVData';
import NodeModalReadDB2 from './flow-builder-form/read/NodeModalReadDB2';
import NodeModalReadDelimited from './flow-builder-form/read/NodeModalReadDelimited';
import NodeModalReadMySql from './flow-builder-form/read/NodeModalReadMySql';
import NodeModalReadOracle from './flow-builder-form/read/NodeModalReadOracle';
import NodeModalReadPostgres from './flow-builder-form/read/NodeModalReadPostgres';
import NodeModalReadPublishedData from './flow-builder-form/read/NodeModalReadPublishedData';
import NodeModalReadSnowflake from './flow-builder-form/read/NodeModalReadSnowflake';
import NodeModalReadStreaming from './flow-builder-form/read/NodeModalReadStreaming';
import NodeModalRulesSelector from './flow-builder-form/read/NodeModalRulesSelector';
import convertToRequiredFormat from './JsonConverter';
import { MAIN } from '../../utils/commonConstants';
import { ETL_COPILOT } from './copilot/copilot-constant/Images';
import NodeModalDataQualityAgent from './flow-builder-form/NodeModal_DataQualityAgent';
import NodeModalDeduplicationAgent from './flow-builder-form/NodeModal_DeduplicationAgent';
import NodeModalDataQualityReport from './flow-builder-form/NodeModal_DataQualityReport';
import NodeModalAbsTransformation from './column-transformations/NodeModal_Abs';
import NodeModalLowerTransformation from './column-transformations/NodeModal_Lower';
import NodeModalUpperTransformation from './column-transformations/NodeModal_Upper';
import NodeModalFloorTransformation from './column-transformations/NodeModal_Floor';
import NodeModalConcatWsTransformation from './column-transformations/NodeModal_ConcatWs';
import NodeModalCurrentTimeStampTransformation from './column-transformations/NodeModal_CurrentTimeStamp';
import NodeModalCurrentDateTransformation from './column-transformations/NodeModal_CurrentDate';
import NodeModalTrimTransformation from './column-transformations/NodeModal_Trim';
import NodeModalRtrimTransformation from './column-transformations/NodeModal_Rtrim';
import NodeModalAddStaticValueTransformation from './column-transformations/NodeModal_AddStaticValue';
import NodeModalInitCapTransformation from './column-transformations/NodeModal_Initcap';
import NodeModalIsNumberTransformation from './column-transformations/NodeModal_IsNumber';
import NodeModalInStrTransformation from './column-transformations/NodeModal_Instr';
import NodeModalIsNullTransformation from './column-transformations/NodeModal_IsNull';
import NodeModalLengthTransformation from './column-transformations/NodeModal_Length';
import NodeModalIndexOfTransformation from './column-transformations/NodeModal_IndexOf';
import NodeModalLtrimTransformation from './column-transformations/NodeModal_Ltrim';
import NodeModalLpadTransformation from './column-transformations/NodeModal_Lpad';
import NodeModalIsSpacesTransformation from './column-transformations/NodeModal_IsSpaces';
import NodeModalCoalesceTransformation from './column-transformations/NodeModal_Coalesce';
import NodeModalRpadTransformation from './column-transformations/NodeModal_Rpad';
import NodeModalReplaceTransformation from './column-transformations/NodeModal_Replace';
import NodeModalSubStrTransformation from './column-transformations/NodeModal_SubStr';
import NodeModalSplitTransformation from './column-transformations/NodeModal_Split';
import NodeModalRegExpReplaceTransformation from './column-transformations/NodeModal_RegExp_Replace';
import NodeModalRoundTransformation from './column-transformations/NodeModal_Round';
import NodeModalRegExpInstrTransformation from './column-transformations/NodeModal_RegExp_Instr';
import NodeModalToDecimalTransformation from './column-transformations/NodeModal_ToDecimal';
import NodeModalToFloatTransformation from './column-transformations/NodeModal_ToFloat';
import NodeModalToIntegerTransformation from './column-transformations/NodeModal_ToInteger';
import NodeModalToBigIntTransformation from './column-transformations/NodeModal_ToBigInt';
import NodeModalRowNumberTransformation from './column-transformations/NodeModal_RowNumber';
import NodeModalModTransformation from './column-transformations/NodeModal_Mod';
import NodeModalPowerTransformation from './column-transformations/NodeModal_Power';
import NodeModalReverseTransformation from './column-transformations/NodeModal_Reverse';
import NodeModalTruncDatesTransformation from './column-transformations/NodeModal_TruncDates';
import NodeModalNullIfTransformation from './column-transformations/NodeModal_NullIf';
import NodeModalRegExpSubStrTransformation from './column-transformations/NodeModal_RegExp_SubStr';
import NodeModalLastDayTransformation from './column-transformations/NodeModal_LastDay';
import NodeModalAddToDateTransformation from './column-transformations/NodeModal_AddToDate';
import NodeModalDateDiffTransformation from './column-transformations/NodeModal_DateDiff';
import NodeModalToDateTransformation from './column-transformations/NodeModal_ToDate';
import NodeModalToCharNumbersTransformation from './column-transformations/NodeModal_ToCharNumbers';
import NodeModalToCharTransformation from './column-transformations/NodeModal_ToChar';
import NodeModalIsDateTransformation from './column-transformations/NodeModal_IsDate';
import NodeModalDateCompareTransformation from './column-transformations/NodeModal_DateCompare';
import NodeModalTruncNumbersTransformation from './column-transformations/NodeModal_TruncNumbers';
import NodeModalRegExtractTransformation from './column-transformations/NodeModal_RegExtract';
import NodeModalRegMatchTransformation from './column-transformations/NodeModal_RegMatch';
import NodeModalCeilTransformation from './column-transformations/NodeModal_Ceil';
import { COLUMN_TRANSFORMATIONS } from '../../constants/Constant';
import NodeModalAutoMapperV2 from './auto-mapper-v2/auto-mapper/NodeModal_AutoMapperV2';

const edgeTypes = {
  buttonedge: ButtonEdge,
};

const getId = () => `dndnode_${+new Date()}`;

const ReactFlowPannel = forwardRef((props, ref) => {
  const [isLabelVisible, setIsLabelVisible] = useState(sessionStorage.getItem('isLabelVisible') === 'true');
  const nodeTypes = useMemo(() => ({ editableNode: CustomNode }), [isLabelVisible]);
  const { userId } = useContext(AuthContext);
  const { workflow, isDisabled, setIsDisabled, setWorkflow } = useContext(WorkflowContext);

  const { enqueueSnackbar } = useSnackbar();

  console.log('current workflow id: ', workflow.workflow_id);

  const reactFlowWrapper = useRef(null);
  const [reactFlowInstance, setReactFlowInstance] = useState(null);
  const [nodes, setNodes] = useNodesState([]);
  const [edges, setEdges] = useEdgesState([]);
  const [nodeName, setNodeName] = useState('');
  const [nodeId, setNodeId] = useState('');
  const [isRotating, setIsRotating] = useState(false);
  const [runExecutionStatus, setRunExecutionStatus] = useState(false);

  const nodeStatusIntervalRef = useRef(null);
  const intervalExecutionListRef = useRef(null);

  const MODALS = {
    [DATA_QUALITY_AGENT.nodeModalTitle]: DATA_QUALITY_AGENT.nodeModalTitle,
    [DEDUPLICATION_AGENT.nodeModalTitle]: DEDUPLICATION_AGENT.nodeModalTitle,
  };

  const isAgenticStream = workflow.process_type === 'Agentic Streams';

  const STATUS_INTERVAL = {
    timerForNodeRefreshStatus: isAgenticStream ? 2250 : 4500,
    timerForExecutionListStatus: isAgenticStream ? 5000 : 10000,
  };


  const handleRunningExectionStatus = async () => {
    try {
      const response = await getWorkflowExecutionByExecutionId(workflow.latest_execution_id);

      if (response?.data?.execution_status?.toLowerCase() === 'running') {
        if (nodeStatusIntervalRef.current === null) {
          nodeStatusIntervalRef.current = setInterval(() => {
            handleRefreshStatus(workflow.latest_execution_id);
          }, STATUS_INTERVAL.timerForNodeRefreshStatus);
        }
      } else {
        if (response?.data?.execution_status.toLowerCase() === 'failed') {
          enqueueSnackbar('Workflow Execution Failed!', {
            variant: 'error',
            autoHideDuration: 3500,
            anchorOrigin: { vertical: 'top', horizontal: 'right' },
          });
        }
        if (response?.data?.execution_status?.toLowerCase() === 'completed') {
          enqueueSnackbar('Workflow Execution Completed!', {
            variant: 'success',
            autoHideDuration: 3500,
            anchorOrigin: { vertical: 'top', horizontal: 'right' },
          });
        }
        setRunExecutionStatus(false);
        clearAllIntervals();
      }
    } catch (error) {
      enqueueSnackbar(
        error.response.status === 404 ? 'Oops! Run the workflow at least once.' : 'Workflow Execution Failed!',
        {
          variant: 'error',
          autoHideDuration: 3500,
          anchorOrigin: { vertical: 'top', horizontal: 'right' },
        }
      );
      setRunExecutionStatus(false);
      clearAllIntervals();
    }
  };

  useEffect(() => {
    if (runExecutionStatus) {
      // Run immediately on click
      handleRunningExectionStatus();
      clearAllIntervals();

      intervalExecutionListRef.current = setInterval(async () => {
        await handleRunningExectionStatus();
      }, STATUS_INTERVAL.timerForExecutionListStatus);
    } else {
      setRunExecutionStatus(false);
      clearAllIntervals();
    }

    // Cleanup on component unmount
    return () => clearAllIntervals();
  }, [workflow?.workflow_id, runExecutionStatus]);

  useEffect(() => {
    if (!workflow.copilotAddedPipeline) return;

    let shouldUpdate = false;

    const updatedNodes = workflow.copilotAddedPipeline.map((item) => {
      if (item.status === 'pending') {
        shouldUpdate = true;

        const createdNodeIds = {};
        const newNodes = [];
        const newEdges = [];

        // Group nodes by step_no to space them vertically
        const levelMap = {};
        item.pipeline.forEach((step) => {
          const level = step.x_level || 0;
          if (!levelMap[level]) levelMap[level] = [];
          levelMap[level].push(step);
        });

        const xGap = 200;
        const yGap = 150;

        Object.entries(levelMap).forEach(([levelStr, steps], levelIndex) => {
          const level = parseInt(levelStr, 10);
          steps.forEach((step, i) => {
            const { previousNodes, currentNode } = step;
            const { nodeId, nodeName } = currentNode;

            const posX = 150 + level * xGap;
            const posY = 100 + i * yGap;

            // Create current node if not already
            if (!createdNodeIds[nodeId]) {
              newNodes.push({
                id: nodeId,
                type: 'editableNode',
                position: { x: posX, y: posY },
                positionAbsolute: { x: posX, y: posY },
                data: {
                  label: nodeName,
                  initNode: nodeName,
                  status: 'unknown',
                  onNodesChange,
                },
                width: 95,
                height: 138,
                selected: false,
                dragging: false,
              });
              createdNodeIds[nodeId] = true;
            }

            // Create edges from previous nodes
            previousNodes?.forEach((prev) => {
              if (!createdNodeIds[prev.nodeId]) {
                const prevPosX = 150 + (level - 1) * xGap;
                const prevPosY = 100 + i * yGap; // Assume similar vertical space

                newNodes.push({
                  id: prev.nodeId,
                  type: 'editableNode',
                  position: { x: prevPosX, y: prevPosY },
                  positionAbsolute: { x: prevPosX, y: prevPosY },
                  data: {
                    label: prev.nodeName,
                    initNode: prev.nodeName,
                    status: 'unknown',
                    onNodesChange,
                  },
                  width: 95,
                  height: 138,
                  selected: false,
                  dragging: false,
                });
                createdNodeIds[prev.nodeId] = true;
              }

              const edgeId = `reactflow__edge-${prev.nodeId}a-${nodeId}`;
              if (!edges.find((e) => e.id === edgeId)) {
                newEdges.push({
                  id: edgeId,
                  source: prev.nodeId,
                  sourceHandle: 'a',
                  target: nodeId,
                  targetHandle: null,
                  type: 'buttonedge',
                  data: { onEdgesChange },
                });
              }
            });
          });
        });

        const elemCount = parseInt(sessionStorage.getItem('elementCount'), 10);
        elemCount
          ? sessionStorage.setItem('elementCount', elemCount + newNodes.length)
          : sessionStorage.setItem('elementCount', newNodes.length);

        setNodes((prev) => [...prev, ...newNodes]);
        setEdges((prev) => [...prev, ...newEdges]);

        setTimeout(() => {
          reactFlowInstance?.fitView();
        }, 500);

        return {
          ...item,
          status: 'completed',
        };
      }
      return item;
    });

    if (shouldUpdate) {
      setWorkflow((prev) => ({
        ...prev,
        copilotAddedPipeline: updatedNodes,
      }));
    }
  }, [workflow.copilotAddedPipeline]);

  useEffect(() => {
    setTimeout(() => {
      if (reactFlowInstance) {
        reactFlowInstance?.fitView();
      }
    }, 500);
  }, [workflow.copilotOpen]);

  useEffect(() => {
    const previousWorkflowStepper = JSON.parse(sessionStorage.getItem('previousWorkflowStepper'));
    const currentWorkflowStepper = JSON.parse(sessionStorage.getItem('workflowStepper'));
    if (currentWorkflowStepper !== previousWorkflowStepper) {
      setTimeout(() => {
        if (reactFlowInstance) {
          reactFlowInstance?.fitView();
        }
      }, 30);
    }
    sessionStorage.setItem('previousWorkflowStepper', JSON.stringify(currentWorkflowStepper));
  }, [reactFlowInstance, nodes]);

  const handleRefreshStatus = async () => {
    setIsRotating(true);
    try {
      const nodeStatus = await getNodeStatusByExecutionId(workflow.latest_execution_id);
      if (nodeStatus.status === 200) {
        sessionStorage.setItem('nodeStatus', JSON.stringify(nodeStatus.data));
      }
    } catch (error) {
      console.log(error);
    } finally {
      setTimeout(() => setIsRotating(false), 1000);
    }
  };

  const handleExecutionStatus = () => {
    if (runExecutionStatus) {
      setRunExecutionStatus(false);
      clearAllIntervals();
    } else {
      setRunExecutionStatus(true);
    }
  };

  const clearAllIntervals = () => {
    if (intervalExecutionListRef.current !== null) {
      clearInterval(intervalExecutionListRef.current);
      intervalExecutionListRef.current = null;
    }
    if (nodeStatusIntervalRef.current !== null) {
      clearInterval(nodeStatusIntervalRef.current);
      nodeStatusIntervalRef.current = null;
    }
  };

  const [modalStates, setModalStates] = useState({});

  const openModal = (modalName) => {
    setModalStates((prev) => ({ ...prev, [modalName]: true }));
  };

  const closeModal = (modalName) => {
    setModalStates((prev) => ({ ...prev, [modalName]: false }));
  };

  const [sortOpen, setSortOpen] = useState(false);
  const handleSortOpen = () => setSortOpen(true);
  const handleSortClose = () => setSortOpen(false);

  const [filterOpen, setFilterOpen] = useState(false);
  const handleFilterOpen = () => setFilterOpen(true);
  const handleFilterClose = () => setFilterOpen(false);

  const [unionOpen, setUnionOpen] = useState(false);
  const handleUnionOpen = () => setUnionOpen(true);
  const handleUnionClose = () => setUnionOpen(false);

  const [joinOpen, setJoinOpen] = useState(false);
  const handleJoinOpen = () => setJoinOpen(true);
  const handleJoinClose = () => setJoinOpen(false);

  const [flatUnionOpen, setFlatUnionOpen] = useState(false);
  const handleFlatUnionOpen = () => setFlatUnionOpen(true);
  const handleFlatUnionClose = () => setFlatUnionOpen(false);

  const [readCsvOpen, setReadCsvOpen] = useState(false);
  const handleReadCsvOpen = () => setReadCsvOpen(true);
  const handleReadCsvClose = () => setReadCsvOpen(false);

  const [readCsvDataOpen, setReadCsvDataOpen] = useState(false);
  const handleReadCsvDataOpen = () => setReadCsvDataOpen(true);
  const handleReadCsvDataClose = () => setReadCsvDataOpen(false);

  const [addColumnOpen, setAddColumnOpen] = useState(false);
  const handleAddColumnOpen = () => setAddColumnOpen(true);
  const handleAddColumnClose = () => setAddColumnOpen(false);

  const [deleteColumnOpen, setDeleteColumnOpen] = useState(false);
  const handleDeleteColumnOpen = () => setDeleteColumnOpen(true);
  const handleDeleteColumnClose = () => setDeleteColumnOpen(false);

  const [visualizationOpen, setVisualizationOpen] = useState(false);
  const handleVisualizationOpen = () => setVisualizationOpen(true);
  const handleVisualizationClose = () => setVisualizationOpen(false);

  const [dataQualityRulesOpen, setDataQualityRulesOpen] = useState(false);
  const handleDataQualityRulesOpen = () => setDataQualityRulesOpen(true);
  const handleDataQualityRulesClose = () => setDataQualityRulesOpen(false);

  const [dataQualityRules2Open, setDataQualityRules2Open] = useState(false);
  const handleDataQualityRules2Open = () => setDataQualityRules2Open(true);
  const handleDataQualityRules2Close = () => setDataQualityRules2Open(false);

  const [pdfDataExtractorOpen, setPdfDataExtractorOpen] = useState(false);
  const handlePdfDataExtractorOpen = () => setPdfDataExtractorOpen(true);
  const handlePdfDataExtractorClose = () => setPdfDataExtractorOpen(false);

  const [dataQualityReportOpen, setDataQualityReportOpen] = useState(false);
  const handleDataQualityReportOpen = () => setDataQualityReportOpen(true);
  const handleDataQualityReportClose = () => setDataQualityReportOpen(false);

  const [rulesSelectorOpen, setRulesSelectorOpen] = useState(false);
  const handleRulesSelectorOpen = () => setRulesSelectorOpen(true);
  const handleRulesSelectorClose = () => setRulesSelectorOpen(false);

  const [automaticRuleGeneratorOpen, setAutomaticRuleGeneratorOpen] = useState(false);
  const handleAutomaticRuleGeneratorOpen = () => setAutomaticRuleGeneratorOpen(true);
  const handleAutomaticRuleGeneratorClose = () => setAutomaticRuleGeneratorOpen(false);

  const [copyDocOpen, setCopyDocOpen] = useState(false);
  const handleCopyDocOpen = () => setCopyDocOpen(true);
  const handleCopyDocClose = () => setCopyDocOpen(false);

  const [readPublishedDataOpen, setReadPublishedDataOpen] = useState(false);
  const handleReadPublishedDataOpen = () => setReadPublishedDataOpen(true);
  const handleReadPublishedDataClose = () => setReadPublishedDataOpen(false);

  const [FileUploaderOpen, setFileUploaderOpen] = useState(false);
  const handleFileUploaderOpen = () => setFileUploaderOpen(true);
  const handleFileUploaderClose = () => setFileUploaderOpen(false);

  const [readStreamingOpen, setReadStreamingOpen] = useState(false);
  const handleReadStreamingOpen = () => setReadStreamingOpen(true);
  const handleReadStreamingClose = () => setReadStreamingOpen(false);

  const [readDelimitedOpen, setReadDelimitedOpen] = useState(false);
  const handleReadDelimitedOpen = () => setReadDelimitedOpen(true);
  const handleReadDelimitedClose = () => setReadDelimitedOpen(false);

  const [dataQualityIssuesOpen, setDataQualityIssuesOpen] = useState(false);
  const handleDataQualityIssuesOpen = () => setDataQualityIssuesOpen(true);
  const handleDataQualityIssuesClose = () => setDataQualityIssuesOpen(false);

  const [dataQualityIssues2Open, setDataQualityIssues2Open] = useState(false);
  const handleDataQualityIssues2Open = () => setDataQualityIssues2Open(true);
  const handleDataQualityIssues2Close = () => setDataQualityIssues2Open(false);

  const [dataProfilingOpen, setDataProfilingOpen] = useState(false);
  const handleDataProfilingOpen = () => setDataProfilingOpen(true);
  const handleDataProfilingClose = () => setDataProfilingOpen(false);

  const [visualInsightsOpen, setVisualInsightsOpen] = useState(false);
  const handleVisualInsightsOpen = () => setVisualInsightsOpen(true);
  const handleVisualInsightsClose = () => setVisualInsightsOpen(false);

  const [readOraclepen, setReadOracleOpen] = useState(false);
  const handleReadOracleOpen = () => setReadOracleOpen(true);
  const handleReadOracleClose = () => setReadOracleOpen(false);

  const [readPostgresOpen, setReadPostgresOpen] = useState(false);
  const handleReadPostgresOpen = () => setReadPostgresOpen(true);
  const handleReadPostgresClose = () => setReadPostgresOpen(false);

  const [fetchSchemaOpen, setFetchSchemaOpen] = useState(false);
  const handleFetchSchemaOpen = () => setFetchSchemaOpen(true);
  const handleFetchSchemaClose = () => setFetchSchemaOpen(false);

  const [readDB2Open, setReadDB2Open] = useState(false);
  const handleReadDB2Open = () => setReadDB2Open(true);
  const handleReadDB2Close = () => setReadDB2Open(false);

  const [readAuroraDBOpen, setReadAuroraDBOpen] = useState(false);
  const handleReadAuroraDBOpen = () => setReadAuroraDBOpen(true);
  const handleReadAuroraDBClose = () => setReadAuroraDBOpen(false);

  const [readCosmosOpen, setReadCosmosOpen] = useState(false);
  const handleReadCosmosOpen = () => setReadCosmosOpen(true);
  const handleReadCosmosClose = () => setReadCosmosOpen(false);

  const [readApiOpen, setReadApiOpen] = useState(false);
  const handleReadApiOpen = () => setReadApiOpen(true);
  const handleReadApiClose = () => setReadApiOpen(false);

  const [readMySqlOpen, setReadMySqlOpen] = useState(false);
  const handleReadMySqlOpen = () => setReadMySqlOpen(true);
  const handleReadMySqlClose = () => setReadMySqlOpen(false);

  const [KPIOpen, setKPIOpen] = useState(false);
  const handleKPIOpen = () => setKPIOpen(true);
  const handleKPIClose = () => setKPIOpen(false);

  const [readSnowflakeOpen, setReadSnowflakeOpen] = useState(false);
  const handleReadSnowflakeOpen = () => setReadSnowflakeOpen(true);
  const handleReadSnowflakeClose = () => setReadSnowflakeOpen(false);

  const [readRealTimeOpen, setReadRealTimeOpen] = useState(false);
  const handleReadRealTimeOpen = () => setReadRealTimeOpen(true);
  const handleReadRealTimeClose = () => setReadRealTimeOpen(false);

  const [llmMapperOpen, setLlmMapperOpen] = useState(false);
  const handleLlmMapperOpen = () => setLlmMapperOpen(true);
  const handleLlmMapperClose = () => setLlmMapperOpen(false);

  const [llmMapperV2Open, setLlmMapperV2Open] = useState(false);
  const handleLlmMapperV2Open = () => setLlmMapperV2Open(true);
  const handleLlmMapperV2Close = () => setLlmMapperV2Open(false);

  const [llmDqRuleOpen, setLlmDqRuleOpen] = useState(false);
  const handleLlmDqRuleOpen = () => setLlmDqRuleOpen(true);
  const handleLlmDqRuleClose = () => setLlmDqRuleOpen(false);

  const [pEInsightsMapperOpen, setPEInsightsMapperOpen] = useState(false);
  const handlePEInsightsMapperOpen = () => setPEInsightsMapperOpen(true);
  const handlePEInsightsMapperClose = () => setPEInsightsMapperOpen(false);

  const [pEDataReportOpen, setPEDataReportOpen] = useState(false);
  const handlePEDataReportOpen = () => setPEDataReportOpen(true);
  const handlePEDataReportClose = () => setPEDataReportOpen(false);

  const [emailOpen, setEmailOpen] = useState(false);
  const handleEmailOpen = () => setEmailOpen(true);
  const handleEmailClose = () => setEmailOpen(false);

  const [cleansingOpen, setCleansingOpen] = useState(false);
  const handleCleansingOpen = () => setCleansingOpen(true);
  const handleCleansingClose = () => setCleansingOpen(false);

  const [sqlOpen, setSqlOpen] = useState(false);
  const handleSqlOpen = () => setSqlOpen(true);
  const handleSqlClose = () => setSqlOpen(false);

  const [writeOpen, setWriteOpen] = useState(false);
  const handleWriteOpen = () => setWriteOpen(true);
  const handleWriteClose = () => setWriteOpen(false);

  const [SnowFlakeOpen, setSnowFlakeOpen] = useState(false);
  const handleSnowFlakeOpen = () => setSnowFlakeOpen(true);
  const handleSnowFlakeClose = () => setSnowFlakeOpen(false);

  const [sourceOpen, setSourceOpen] = useState(false);
  const handleSourceOpen = () => setSourceOpen(true);
  const handleSourceClose = () => setSourceOpen(false);

  const [OpenSearchOpen, setOpenSearchOpen] = useState(false);
  const handleopenSearchOpen = () => setOpenSearchOpen(true);
  const handleOpenSearchClose = () => setOpenSearchOpen(false);

  const [WriteSFTPOpen, setWriteSFTPOpen] = useState(false);
  const handleWriteSFTPOpen = () => setWriteSFTPOpen(true);
  const handleWriteSFTPClose = () => setWriteSFTPOpen(false);

  const [DatabaseOpen, setDatabaseOpen] = useState(false);
  const handleDatabaseOpen = () => setDatabaseOpen(true);
  const handleDatabaseClose = () => setDatabaseOpen(false);

  const [aggregateOpen, setAggregateOpen] = useState(false);
  const handleAggregateOpen = () => setAggregateOpen(true);
  const handleAggregateClose = () => setAggregateOpen(false);

  const [C360Open, setC360Open] = useState(false);
  const handleC360Open = () => setC360Open(true);
  const handleC360Close = () => setC360Open(false);

  const [udfOpen, setUdfOpen] = useState(false);
  const handleUdfOpen = () => setUdfOpen(true);
  const handleUdfClose = () => setUdfOpen(false);

  const [coaleaseOpen, setCoaleaseOpen] = useState(false);
  const handleCoaleaseOpen = () => setCoaleaseOpen(true);
  const handleCoaleaseClose = () => setCoaleaseOpen(false);

  const [datatypeConvOpen, setDatatypeConvOpen] = useState(false);
  const handleDatatypeConvOpen = () => setDatatypeConvOpen(true);
  const handleDatatypeConvClose = () => setDatatypeConvOpen(false);

  const [dateTimeOpen, setDateTimeOpen] = useState(false);
  const handleDateTimeOpen = () => setDateTimeOpen(true);
  const handleDateTimeClose = () => setDateTimeOpen(false);

  const [nullOpen, setNullOpen] = useState(false);
  const handleNullOpen = () => setNullOpen(true);
  const handleNullClose = () => setNullOpen(false);

  const [ingestionWriteOpen, setIngestionWriteOpen] = useState(false);
  const handleIngestionWriteOpen = () => setIngestionWriteOpen(true);
  const handleIngestionWriteClose = () => setIngestionWriteOpen(false);

  const [trainingOpen, setTrainingOpen] = useState(false);
  const handleTrainingOpen = () => setTrainingOpen(true);
  const handleTrainingClose = () => setTrainingOpen(false);

  const [predictionOpen, setPredictionOpen] = useState(false);
  const handlePredictionOpen = () => setPredictionOpen(true);
  const handlePredictionClose = () => setPredictionOpen(false);

  const [profilingOpen, setProfilingOpen] = useState(false);
  const handleProfilingOpen = () => setProfilingOpen(true);
  const handleProfilingClose = () => setProfilingOpen(false);

  const [mathTransformationOpen, setMathTransformationOpen] = useState(false);
  const handleMathTransformationOpen = () => setMathTransformationOpen(true);
  const handleMathTransformationClose = () => setMathTransformationOpen(false);

  const [dataValidationOpen, setDataValidationOpen] = useState(false);
  const handleDataValidationOpen = () => setDataValidationOpen(true);
  const handleDataValidationClose = () => setDataValidationOpen(false);

  const [oneHotEncoderOpen, setOneHotEncoderOpen] = useState(false);
  const handleOneHotEncoderOpen = () => setOneHotEncoderOpen(true);
  const handleOneHotEncoderClose = () => setOneHotEncoderOpen(false);

  const [labelEncoderOpen, setLabelEncoderOpen] = useState(false);
  const handleLabelEncoderOpen = () => setLabelEncoderOpen(true);
  const handleLabelEncoderClose = () => setLabelEncoderOpen(false);

  const [isDataLineage, setIsDataLineage] = useState(false);
  const handleDataLineage = () => setIsDataLineage(!isDataLineage);
  const [dropOpen, setDropOpen] = useState(false);
  const handleDropOpen = () => setDropOpen(true);
  const handleDropClose = () => setDropOpen(false);

  const [imbalancedDataOpen, setImbalancedDataOpen] = useState(false);
  const handleImbalancedDataOpen = () => setImbalancedDataOpen(true);
  const handleImbalancedDataClose = () => setImbalancedDataOpen(false);

  const [imbalancedDataSamplingOpen, setImbalancedDataSamplingOpen] = useState(false);
  const handleImbalancedDataSamplingOpen = () => setImbalancedDataSamplingOpen(true);
  const handleImbalancedDataSamplingClose = () => setImbalancedDataSamplingOpen(false);

  const [outlierOpen, setOutlierOpen] = useState(false);
  const handleOutlierOpen = () => setOutlierOpen(true);
  const handleOutlierClose = () => setOutlierOpen(false);

  const [scalerOpen, setScalerOpen] = useState(false);
  const handleScalerOpen = () => setScalerOpen(true);
  const handleScalerClose = () => setScalerOpen(false);

  const [resampleOpen, setResampleOpen] = useState(false);
  const handleResampleOpen = () => setResampleOpen(true);
  const handleResampleClose = () => setResampleOpen(false);

  const [swapColumnOpen, setSwapColumnOpen] = useState(false);
  const handleSwapColumnOpen = () => setSwapColumnOpen(true);
  const handleSwapColumnClose = () => setSwapColumnOpen(false);

  const [duplicacyOpen, setDuplicacyOpen] = useState(false);
  const handleDuplicacyOpen = () => setDuplicacyOpen(true);
  const handleDuplicacyClose = () => setDuplicacyOpen(false);

  const [countBlockOpen, setCountBlockOpen] = useState(false);
  const handleCountBlockOpen = () => setCountBlockOpen(true);
  const handleCountBlockClose = () => setCountBlockOpen(false);

  const [readCsvOpen2, setReadCsvOpen2] = useState(false);
  const handleReadCsvOpen2 = () => setReadCsvOpen2(true);
  const handleReadCsvClose2 = () => setReadCsvOpen2(false);

  const [readCsvAzureOpen, setReadCsvAzureOpen] = useState(false);
  const handleReadCsvAzureOpen = () => setReadCsvAzureOpen(true);
  const handleReadCsvAzureClose = () => setReadCsvAzureOpen(false);

  const [writeCsvAWSOpen, setWriteCsvAWSOpen] = useState(false);
  const handleWriteCsvAWSOpen = () => setWriteCsvAWSOpen(true);
  const handleWriteCsvAWSClose = () => setWriteCsvAWSOpen(false);

  const [WriteAzureOpen, setWriteAzureOpen] = useState(false);
  const handleWriteAzureOpen = () => setWriteAzureOpen(true);
  const handleWriteAzureClose = () => setWriteAzureOpen(false);

  const [readPostgres2Open, setReadPostgres2Open] = useState(false);
  const handleReadPostgres2Open = () => setReadPostgres2Open(true);
  const handleReadPostgres2Close = () => setReadPostgres2Open(false);

  const [writePostgresOpen, setWritePostgresOpen] = useState(false);
  const handleWritePostgresOpen = () => setWritePostgresOpen(true);
  const handleWritePostgresClose = () => setWritePostgresOpen(false);

  const [readSnowflake2Open, setReadSnowflake2Open] = useState(false);
  const handleReadSnowflake2Open = () => setReadSnowflake2Open(true);
  const handleReadSnowflake2Close = () => setReadSnowflake2Open(false);

  const [writeSnowflakeOpen, setWriteSnowflakeOpen] = useState(false);
  const handleWriteSnowflakeOpen = () => setWriteSnowflakeOpen(true);
  const handleWriteSnowflakeClose = () => setWriteSnowflakeOpen(false);

  const [writeOracleDBOpen, setWriteOracleDBOpen] = useState(false);
  const handleWriteOracleDBOpen = () => setWriteOracleDBOpen(true);
  const handleWriteOracleDBClose = () => setWriteOracleDBOpen(false);

  const [readOracleDBOpen, setReadOracleDBOpen] = useState(false);
  const handleReadOracleDBOpen = () => setReadOracleDBOpen(true);
  const handleReadOracleDBClose = () => setReadOracleDBOpen(false);

  const [ReadSQLServerOpen, setReadSQLServerOpen] = useState(false);
  const handleReadSQLServerOpen = () => setReadSQLServerOpen(true);
  const handleReadSQLServerClose = () => setReadSQLServerOpen(false);

  const [writeSqlServerOpen, setWriteSqlServerOpen] = useState(false);
  const handleWriteSqlServerOpen = () => setWriteSqlServerOpen(true);
  const handleWriteSqlServerClose = () => setWriteSqlServerOpen(false);

  // const [readMdmOpen, setReadMdmOpen] = useState(false);
  // const handleReadMdmOpen = () => setReadMdmOpen(true);
  // const handleReadMdmClose = () => setReadMdmOpen(false);

  const [fuzzyMatchOpen, setFuzzyMatchOpen] = useState(false);
  const handleFuzzyMatchOpen = () => setFuzzyMatchOpen(true);
  const handleFuzzyMatchClose = () => setFuzzyMatchOpen(false);

  const [ruleEngineOpen, setRuleEngineOpen] = useState(false);
  const handleRuleEngineOpen = () => setRuleEngineOpen(true);
  const handleRuleEngineClose = () => setRuleEngineOpen(false);

  const [manualMergeOpen, setManualMergeOpen] = useState(false);
  const handleManualMergeOpen = () => setManualMergeOpen(true);
  const handleManualMergeClose = () => setManualMergeOpen(false);

  const [segmentationOpen, setSegmentationOpen] = useState(false);
  const handleSegmentationOpen = () => setSegmentationOpen(true);
  const handleSegmentationClose = () => setSegmentationOpen(false);

  const [custSegmentationOpen, setCustSegmentationOpen] = useState(false);
  const handleCustSegmentationOpen = () => setCustSegmentationOpen(true);
  const handleCustSegmentationClose = () => setCustSegmentationOpen(false);

  const [clusterOpen, setClusterOpen] = useState(false);
  const handleClusterOpen = () => setClusterOpen(true);
  const handleClusterClose = () => setClusterOpen(false);

  const [plotOpen, setPlotOpen] = useState(false);
  const handlePlotOpen = () => setPlotOpen(true);
  const handlePlotClose = () => setPlotOpen(false);

  const [analysisOpen, setAnalysisOpen] = useState(false);
  const handleAnalysisOpen = () => setAnalysisOpen(true);
  const handleAnalysisClose = () => setAnalysisOpen(false);

  const [rfmOpen, setRfmOpen] = useState(false);
  const handleRfmOpen = () => setRfmOpen(true);
  const handleRfmClose = () => setRfmOpen(false);

  const [transformationOpen, setTransformationOpen] = useState(false);
  const handleTransformationOpen = () => setTransformationOpen(true);
  const handleTransformationClose = () => setTransformationOpen(false);

  const onConnect = useCallback((params) => {
    setEdges((eds) =>
      addEdge(
        {
          ...params,
          type: 'buttonedge',
          data: { onEdgesChange },
        },
        eds
      )
    );
  }, []);

  const handleLabelVisible = async () => {
    setIsLabelVisible(!isLabelVisible);
    sessionStorage.setItem('isLabelVisible', !isLabelVisible);
  };
  const transformationModalMap = {
    abs: NodeModalAbsTransformation,
    lower: NodeModalLowerTransformation,
    upper: NodeModalUpperTransformation,
    floor: NodeModalFloorTransformation,
    concat_ws: NodeModalConcatWsTransformation,
    current_date: NodeModalCurrentDateTransformation,
    current_time: NodeModalCurrentTimeStampTransformation,
    trim: NodeModalTrimTransformation,
    initcap: NodeModalInitCapTransformation,
    isnumber: NodeModalIsNumberTransformation,
    instr: NodeModalInStrTransformation,
    isnull: NodeModalIsNullTransformation,
    length: NodeModalLengthTransformation,
    indexof: NodeModalIndexOfTransformation,
    ltrim: NodeModalLtrimTransformation,
    lpad: NodeModalLpadTransformation,
    isspaces: NodeModalIsSpacesTransformation,
    coalesce: NodeModalCoalesceTransformation,
    rpad: NodeModalRpadTransformation,
    replace: NodeModalReplaceTransformation,
    substr: NodeModalSubStrTransformation,
    split: NodeModalSplitTransformation,
    regexp_replace: NodeModalRegExpReplaceTransformation,
    round: NodeModalRoundTransformation,
    regexp_instr: NodeModalRegExpInstrTransformation,
    to_decimal: NodeModalToDecimalTransformation,
    to_float: NodeModalToFloatTransformation,
    to_integer: NodeModalToIntegerTransformation,
    to_bigint: NodeModalToBigIntTransformation,
    row_number: NodeModalRowNumberTransformation,
    mod: NodeModalModTransformation,
    power: NodeModalPowerTransformation,
    reverse: NodeModalReverseTransformation,
    trunc_dates: NodeModalTruncDatesTransformation,
    nullif: NodeModalNullIfTransformation,
    regexp_substr: NodeModalRegExpSubStrTransformation,
    add_to_date: NodeModalAddToDateTransformation,
    last_day: NodeModalLastDayTransformation,
    date_diff: NodeModalDateDiffTransformation,
    to_date: NodeModalToDateTransformation,
    add_static_value: NodeModalAddStaticValueTransformation,
    rtrim: NodeModalRtrimTransformation,
    to_char_numbers: NodeModalToCharNumbersTransformation,
    is_date: NodeModalIsDateTransformation,
    to_char: NodeModalToCharTransformation,
    date_compare: NodeModalDateCompareTransformation,
    trunc_numbers: NodeModalTruncNumbersTransformation,
    reg_match: NodeModalRegMatchTransformation,
    reg_extract: NodeModalRegExtractTransformation,
    ceil: NodeModalCeilTransformation,
  };


  const ModalComponent = transformationModalMap[nodeName];


  const onEdgeUpdate = (oldEdge, newConnection) => setEdges((els) => updateEdge(oldEdge, newConnection, els));

  const onNodesChange = useCallback((changes) => {
    if (changes[0].type === 'remove') {
      const getElementsId = JSON.parse(sessionStorage.getItem('saved_node')) || [];
      let updateNodes = JSON.parse(sessionStorage.getItem('updatedNodes')) || [];

      const updatedSavedNodes = getElementsId.filter((el) => el !== changes[0].id);
      updateNodes = updateNodes.filter((el) => el !== changes[0].id);

      sessionStorage.setItem('saved_node', JSON.stringify(updatedSavedNodes));
      sessionStorage.setItem('updatedNodes', JSON.stringify(updateNodes));

      setNodes((ns) => applyNodeChanges(changes, ns));

      const getAllNodes = JSON.parse(sessionStorage.getItem('allNodes'));

      if (getAllNodes) {
        getAllNodes.forEach((el, i) => {
          if (el.nodeId === changes[0].id) {
            getAllNodes.splice(i, 1);
            sessionStorage.setItem('allNodes', JSON.stringify(getAllNodes));
          }
        });
      }

      const elemCount = parseInt(sessionStorage.getItem('elementCount'), 10);

      elemCount && sessionStorage.setItem('elementCount', elemCount - 1);

      setNodeName('');
      setNodeId('');
    } else {
      setNodes((ns) => applyNodeChanges(changes, ns));
    }
  }, []);

  const onEdgesChange = useCallback((changes) => {
    setEdges((es) => applyEdgeChanges(changes, es));
  }, []);

  const onDragOver = useCallback((event) => {
    event.preventDefault();
    event.dataTransfer.dropEffect = 'move';
  }, []);

  const onDrop = useCallback(
    (event) => {
      event.preventDefault();

      const reactFlowBounds = reactFlowWrapper.current.getBoundingClientRect();
      const type = event.dataTransfer.getData('application/reactflow');
      const name = event.dataTransfer.getData('nodeName');
      // const className = event.dataTransfer.getData('className');

      // check if the dropped element is valid
      if (typeof type === 'undefined' || !type) {
        return;
      }

      const position = reactFlowInstance.project({
        x: event.clientX - reactFlowBounds.left,
        y: event.clientY - reactFlowBounds.top,
      });
      const newNode = {
        id: getId(),
        type,
        position,
        data: { label: `${name}`, initNode: `${name}`, onNodesChange },
      };

      const elemCount = parseInt(sessionStorage.getItem('elementCount'), 10);

      elemCount ? sessionStorage.setItem('elementCount', elemCount + 1) : sessionStorage.setItem('elementCount', 1);

      setNodes((nds) => nds.concat(newNode));
    },
    [reactFlowInstance]
  );

  const onNodeClick = (event, node) => {
    if (nodeName || nodeId) {
      setNodeName('');
      setNodeId('');
    }

    setNodeId(node.id);
    setNodeName(node.data.initNode);

    if (node.data.initNode === DATA_QUALITY_AGENT.nodeModalTitle) {
      openModal(MODALS[DATA_QUALITY_AGENT.nodeModalTitle]);
    }

    if (node.data.initNode === DEDUPLICATION_AGENT.nodeModalTitle) {
      openModal(MODALS[DEDUPLICATION_AGENT.nodeModalTitle]);
    }

    // if (node.height === 174) {
    if (node.data.initNode === 'Sort') {
      handleSortOpen();
    }

    if (node.data.initNode === 'Filter') {
      handleFilterOpen();
    }

    if (node.data.initNode === 'Union') {
      handleUnionOpen();
    }

    if (node.data.initNode === 'FlatUnion') {
      handleFlatUnionOpen();
    }

    if (node.data.initNode === 'DataQualityIssues') {
      handleDataQualityIssuesOpen();
    }
    if (node.data.initNode === 'DataQualityIssues2') {
      handleDataQualityIssues2Open();
    }
    if (node.data.initNode === 'DataProfiling') {
      handleDataProfilingOpen();
    }

    if (COLUMN_TRANSFORMATIONS.includes(node.data.initNode)) {
      handleTransformationOpen();
    }

    if (node.data.initNode === 'VisualInsights') {
      handleVisualInsightsOpen();
    }

    if (node.data.initNode === 'Join') {
      handleJoinOpen();
    }
    if (node.data.initNode === 'ReadCSV') {
      handleReadCsvOpen();
    }
    if (node.data.initNode === 'AddColumn') {
      handleAddColumnOpen();
    }
    if (node.data.initNode === 'DeleteColumn') {
      handleDeleteColumnOpen();
    }
    if (node.data.initNode === 'ReadCSVData') {
      handleReadCsvDataOpen();
    }
    if (node.data.initNode === 'Visualization') {
      handleVisualizationOpen();
    }
    if (node.data.initNode === DATA_QUALITY_RULES.nodeModalTitle) {
      handleDataQualityRulesOpen();
    }
    if (node.data.initNode === DATA_QUALITY_RULES2.nodeModalTitle) {
      handleDataQualityRules2Open();
    }
    if (node.data.initNode === 'PdfDataExtractor') {
      handlePdfDataExtractorOpen();
    }

    if (node.data.initNode === DATA_QUALITY_REPORT.nodeModalTitle) {
      handleDataQualityReportOpen();
    }
    if (node.data.initNode === 'Rules Selector') {
      handleRulesSelectorOpen();
    }
    if (node.data.initNode === 'AutomaticRuleGenerator') {
      handleAutomaticRuleGeneratorOpen();
    }
    if (node.data.initNode === 'CopyDoc') {
      handleCopyDocOpen();
    }
    if (node.data.initNode === 'ReadPublishedData') {
      handleReadPublishedDataOpen();
    }
    if (node.data.initNode === 'FileUploader') {
      handleFileUploaderOpen();
    }
    if (node.data.initNode === 'ReadStreaming') {
      handleReadStreamingOpen();
    }
    if (node.data.initNode === 'ReadDelimited') {
      handleReadDelimitedOpen();
    }
    if (node.data.initNode === 'ReadOracle') {
      handleReadOracleOpen();
    }
    if (node.data.initNode === 'ReadPostgres') {
      handleReadPostgresOpen();
    }
    if (node.data.initNode === FETCH_SCHEMA.nodeModalTitle) {
      handleFetchSchemaOpen();
    }
    if (node.data.initNode === 'ReadDB2') {
      handleReadDB2Open();
    }
    if (node.data.initNode === 'ReadAuroraDB') {
      handleReadAuroraDBOpen();
    }
    if (node.data.initNode === 'ReadCosmos') {
      handleReadCosmosOpen();
    }
    if (node.data.initNode === 'ReadApi') {
      handleReadApiOpen();
    }
    if (node.data.initNode === 'ReadMySql') {
      handleReadMySqlOpen();
    }

    if (node.data.initNode === 'ReadSnowflake') {
      handleReadSnowflakeOpen();
    }

    if (node.data.initNode === 'Read Real-Time') {
      handleReadRealTimeOpen();
    }


    if (node.data.initNode === 'Email') {
      handleEmailOpen();
    }

    if (node.data.initNode === 'Data Cleansing') {
      handleCleansingOpen();
    }

    if (node.data.initNode === 'KPI') {
      handleKPIOpen();
    }
    if (node.data.initNode === 'Execute SQL') {
      handleSqlOpen();
    }

    if (node.data.initNode === LLM_MAPPER.nodeModalTitle) {
      handleLlmMapperOpen();
    }

    if (node.data.initNode === LLM_MAPPER_V2.nodeModalTitle) {
      handleLlmMapperV2Open();
    }

    if (node.data.initNode === PE_INSIGHTS_MAPPER.nodeModalTitle) {
      handlePEInsightsMapperOpen();
    }
    if (node.data.initNode === PE_DATA_REPORT.nodeModalTitle) {
      handlePEDataReportOpen();
    }

    if (node.data.initNode === 'Write') {
      handleWriteOpen();
    }

    if (node.data.initNode === 'SnowFlake') {
      handleSnowFlakeOpen();
    }

    if (node.data.initNode === 'OpenSearch') {
      handleopenSearchOpen();
    }

    if (node.data.initNode === 'WriteSFTP') {
      handleWriteSFTPOpen();
    }

    if (node.data.initNode === 'Postgres') {
      handleDatabaseOpen();
    }

    if (node.data.initNode === 'Aggregation' || node.data.initNode === 'StatisticalAggregation') {
      handleAggregateOpen();
    }

    if (node.data.initNode === 'SwapColumn') {
      handleSwapColumnOpen();
    }
    if (node.data.initNode === 'CountBlock') {
      handleCountBlockOpen();
    }
    if (node.data.initNode === 'DuplicacyCheck') {
      handleDuplicacyOpen();
    }
    if (node.data.initNode === 'ReadCSVAws') {
      handleReadCsvOpen2();
    }
    if (node.data.initNode === 'ReadCSVAzure') {
      handleReadCsvAzureOpen();
    }

    if (node.data.initNode === 'WriteCsvAWS') {
      handleWriteCsvAWSOpen();
    }

    if (node.data.initNode === 'WriteAzure') {
      handleWriteAzureOpen();
    }

    if (node.data.initNode === 'ReadPostgres2') {
      handleReadPostgres2Open();
    }

    if (node.data.initNode === 'WritePostgres') {
      handleWritePostgresOpen();
    }

    if (node.data.initNode === 'ReadSnowflake2') {
      handleReadSnowflake2Open();
    }

    if (node.data.initNode === 'WriteSnowflake') {
      handleWriteSnowflakeOpen();
    }
    if (node.data.initNode === 'ReadOracleDB') {
      handleReadOracleDBOpen();
    }
    if (node.data.initNode === 'WriteOracleDB') {
      handleWriteOracleDBOpen();
    }
    if (node.data.initNode === 'ReadSQLServer') {
      handleReadSQLServerOpen();
    }
    if (node.data.initNode === 'WriteSqlServer') {
      handleWriteSqlServerOpen();
    }
    if (node.data.initNode === 'C360') {
      handleC360Open();
    }

    if (node.data.initNode === 'Udf') {
      handleUdfOpen();
    }

    if (node.data.initNode === 'Coalesce') {
      handleCoaleaseOpen();
    }

    if (node.data.initNode === 'Datatype Conversion') {
      handleDatatypeConvOpen();
    }


    if (node.data.initNode === 'Date Time Feature') {
      handleDateTimeOpen();
    }

    if (node.data.initNode === 'Handle Null') {
      handleNullOpen();
    }

    if (node.data.initNode === 'Ingestion Write') {
      handleIngestionWriteOpen();
    }

    if (node.data.initNode === 'Training') {
      handleTrainingOpen();
    }

    if (node.data.initNode === 'Prediction') {
      handlePredictionOpen();
    }


    if (node.data.initNode === 'Source') {
      handleSourceOpen();
    }

    if (node.data.initNode === 'Profiling') {
      handleProfilingOpen();
    }

    if (node.data.initNode === 'Math Transformation') {
      handleMathTransformationOpen();
    }

    if (node.data.initNode === 'DataValidation') {
      handleDataValidationOpen();
    }

    if (node.data.initNode === 'OneHot Encoder') {
      handleOneHotEncoderOpen();
    }

    if (node.data.initNode === 'Label Encoder') {
      handleLabelEncoderOpen();
    }

    if (node.data.initNode === 'Drop') {
      handleDropOpen();
    }

    if (node.data.initNode === 'Imbalanced Data') {
      handleImbalancedDataOpen();
    }

    if (node.data.initNode === 'Imbalanced Data Sampling') {
      handleImbalancedDataSamplingOpen();
    }

    if (node.data.initNode === 'Outlier') {
      handleOutlierOpen();
    }

    if (node.data.initNode === 'Scaler') {
      handleScalerOpen();
    }

    if (node.data.initNode === 'Resample') {
      handleResampleOpen();
    }

    if (node.data.initNode === 'Fuzzy Match') {
      handleFuzzyMatchOpen();
    }

    if (node.data.initNode === 'Data Cleaning & Validation') {
      handleRuleEngineOpen();
    }

    if (node.data.initNode === 'Match & Merge') {
      handleManualMergeOpen();
    }

    if (node.data.initNode === 'Customer Segmentation') {
      handleCustSegmentationOpen();
    }
    if (node.data.initNode === 'Segment') {
      handleSegmentationOpen();
    }
    if (node.data.initNode === 'Dedupe') {
      handleClusterOpen();
    }
    if (node.data.initNode === 'Plot') {
      handlePlotOpen();
    }

    if (node.data.initNode === 'Analysis') {
      handleAnalysisOpen();
    }
    if (node.data.initNode === LLM_DQ_RULES.nodeModalTitle) {
      handleLlmDqRuleOpen();
    }
    if (node.data.initNode === LLM_DQ_RULES_2.nodeModalTitle) {
      handleLlmDqRuleOpen();
    }
    if (node.data.initNode === 'RFM') {
      handleRfmOpen();
    }
  };

  const changeNodeName = (newNode) => {
    newNode.forEach((el) => {
      el.data.onNodesChange = onNodesChange;
    });
    setNodes(newNode);
  };

  const resetElements = () => {
    setNodes([]);
  };

  const getNodeData = JSON.parse(sessionStorage.getItem('saved_node'));
  const switchWorkflowStepper = JSON.parse(sessionStorage.getItem('workflowStepper'));

  useEffect(() => {
    const fetchNodes = JSON.parse(sessionStorage.getItem('node'));
    const fetchEdges = JSON.parse(sessionStorage.getItem('edges'));

    if (fetchEdges && fetchNodes) {
      fetchNodes.forEach((el) => {
        el.data.onNodesChange = onNodesChange;
      });
      fetchEdges.forEach((el) => {
        el.data.onEdgesChange = onEdgesChange;
      });

      setNodes(fetchNodes);
      setEdges(fetchEdges);
    }
  }, [isRotating, switchWorkflowStepper]);

  useEffect(() => {
    setIsDisabled(false);

    if (nodes.length === 0 || getNodeData?.length === 0 || getNodeData === null) {
      setIsDisabled(true);
    }
  }, [isDisabled, nodes, getNodeData]);

  const submitDataProcessor = async () => {
    props.setLoading(true);
    try {
      if (nodes.length === 0) {
        props.setLoading(false);
      }
      const newEdges = [];

      edges.forEach((el) => {
        const source = nodes.filter((item) => item.id === el.source);
        const target = nodes.filter((item) => item.id === el.target);

        if (source.length > 0 && target.length > 0) {
          newEdges.push(el);
        }
      });

      const getAllDataFromLocalStorage = JSON.parse(sessionStorage.getItem('allNodes'));

      getAllDataFromLocalStorage.map((item) => {
        nodes.forEach((el) => {
          if (item.nodeId === el.id) {
            item.y_axis = parseInt(el.position.x, 10);
          }
        });
      });

      getAllDataFromLocalStorage.sort((a, b) => a.y_axis - b.y_axis);

      const getNodeData = JSON.parse(sessionStorage.getItem('saved_node'));

      const getElementCount = parseInt(sessionStorage.getItem('elementCount'), 10) || '';

      if (getNodeData.length === getElementCount) {
        let count = 1;
        getAllDataFromLocalStorage.forEach((el) => {
          el.formField.step_no = count;
          count++;
        });

        getAllDataFromLocalStorage.sort((a, b) => a.formField.step_no - b.formField.step_no);

        const tempFormData = getAllDataFromLocalStorage;

        tempFormData.forEach((el) => {
          if (el.nodeName === 'Data Cleansing') {
            el.cleansingRules = el.cleansingRules.filter((el) => {
              return !el.deleted;
            });
          }
        });

        tempFormData.forEach((el) => {
          if (el.nodeName === 'Data Cleansing') {
            el.initial_rules = el.cleansingRules;
          }
        });

        const createFormData = {
          workflow_id: workflow.workflow_id,
          execution_mode: workflow.execution_mode,
          form_data: tempFormData,
          nodes,
          edges: newEdges,
          spark_config_json: convertToRequiredFormat(tempFormData, '', workflow.workflow_id),
        };

        const user_id = userId;
        const createForm = await createDataProcessorApi(createFormData, user_id);

        if (createForm.status === 201) {
          sessionStorage.removeItem('allNodes');
          sessionStorage.removeItem('node');
          sessionStorage.removeItem('edges');
          sessionStorage.removeItem('nodeStatus');
          sessionStorage.removeItem('elementCount');
          sessionStorage.removeItem('saved_node');

          enqueueSnackbar('Steps and Data are saved!', {
            variant: 'success',
            autoHideDuration: 3000,
            anchorOrigin: { vertical: 'top', horizontal: 'right' },
          });

          resetElements();
        }

        console.log(convertToRequiredFormat(tempFormData, '', ''));
      }
    } catch (error) {
      console.log(error);
      if (error.response.status === 403) {
        enqueueSnackbar('You have only Read Permission !!', {
          variant: 'error',
          autoHideDuration: 3000,
          anchorOrigin: { vertical: 'top', horizontal: 'right' },
        });
      }
      if (error.response.status === 500) {
        enqueueSnackbar('Something went wrong !!', {
          variant: 'error',
          autoHideDuration: 3000,
          anchorOrigin: { vertical: 'top', horizontal: 'right' },
        });
      }
    }
    props.setLoading(false);
  };

  ref.current = submitDataProcessor;

  const proOptions = { hideAttribution: true };

  return (
    <>
      <Paper
        elevation={5}
        style={{ padding: ' 10px', overflow: 'visible', display: 'flex', flexDirection: 'row' }}
        className="react-flow-wrappper"
      >
        <div className="node-sec">
          <NodesSection />
        </div>
        <div className="dndflow">
          <ReactFlowProvider>
            {nodeName === 'Write' && nodes && (
              <NodeModalWrite
                key={nodeId}
                nodeId={nodeId}
                changeNodeName={changeNodeName}
                nodeName={nodeName}
                nodes={nodes}
                edges={edges}
                open={writeOpen}
                setNodes={setNodes}
                handleClose={handleWriteClose}
              />
            )}

            {nodeName === 'Source' && nodes && (
              <NodeModalSource
                key={nodeId}
                nodeId={nodeId}
                nodeName={nodeName}
                changeNodeName={changeNodeName}
                nodes={nodes}
                edges={edges}
                open={sourceOpen}
                setNodes={setNodes}
                handleClose={handleSourceClose}
              />
            )}

            {nodeName === 'Datatype Conversion' && nodes && (
              <NodeModalDatatypeConv
                key={nodeId}
                nodeId={nodeId}
                nodeName={nodeName}
                changeNodeName={changeNodeName}
                nodes={nodes}
                edges={edges}
                open={datatypeConvOpen}
                setNodes={setNodes}
                handleClose={handleDatatypeConvClose}
              />
            )}
            {nodeName === 'Date Time Feature' && nodes && (
              <NodeModalDateTime
                key={nodeId}
                nodeId={nodeId}
                nodeName={nodeName}
                changeNodeName={changeNodeName}
                nodes={nodes}
                edges={edges}
                open={dateTimeOpen}
                setNodes={setNodes}
                handleClose={handleDateTimeClose}
              />
            )}
            {nodeName === 'Handle Null' && nodes && (
              <NodeModalHandleNull
                key={nodeId}
                nodeId={nodeId}
                nodeName={nodeName}
                changeNodeName={changeNodeName}
                nodes={nodes}
                edges={edges}
                open={nullOpen}
                setNodes={setNodes}
                handleClose={handleNullClose}
              />
            )}

            {nodeName === 'OneHot Encoder' && nodes && (
              <NodeModalOneHotEncoder
                key={nodeId}
                nodeId={nodeId}
                nodeName={nodeName}
                changeNodeName={changeNodeName}
                nodes={nodes}
                edges={edges}
                open={oneHotEncoderOpen}
                setNodes={setNodes}
                handleClose={handleOneHotEncoderClose}
              />
            )}
            {nodeName === 'StatisticalAggregation' && nodes && (
              <NodeModalStatisticalAggregation
                key={nodeId}
                nodeId={nodeId}
                nodeName={nodeName}
                changeNodeName={changeNodeName}
                nodes={nodes}
                edges={edges}
                open={aggregateOpen}
                setNodes={setNodes}
                handleClose={handleAggregateClose}
              />
            )}
            {nodeName === 'SwapColumn' && nodes && (
              <NodeModalSwapColumn
                key={nodeId}
                nodeId={nodeId}
                nodeName={nodeName}
                changeNodeName={changeNodeName}
                nodes={nodes}
                edges={edges}
                open={swapColumnOpen}
                setNodes={setNodes}
                handleClose={handleSwapColumnClose}
                workflow={workflow}
              />
            )}
            {nodeName === 'CountBlock' && nodes && (
              <NodeModalCountBlock
                key={nodeId}
                nodeId={nodeId}
                nodeName={nodeName}
                changeNodeName={changeNodeName}
                nodes={nodes}
                edges={edges}
                open={countBlockOpen}
                setNodes={setNodes}
                handleClose={handleCountBlockClose}
                workflow={workflow}
              />
            )}
            {nodeName === 'DuplicacyCheck' && nodes && (
              <NodeModalDuplicacyCheck
                key={nodeId}
                nodeId={nodeId}
                nodeName={nodeName}
                changeNodeName={changeNodeName}
                nodes={nodes}
                edges={edges}
                open={duplicacyOpen}
                setNodes={setNodes}
                handleClose={handleDuplicacyClose}
              />
            )}

            {nodeName === 'Outlier' && nodes && (
              <NodeModalOutlier
                key={nodeId}
                nodeId={nodeId}
                nodeName={nodeName}
                changeNodeName={changeNodeName}
                nodes={nodes}
                edges={edges}
                open={outlierOpen}
                setNodes={setNodes}
                handleClose={handleOutlierClose}
              />
            )}

            {nodeName === 'Imbalanced Data' && nodes && (
              <NodeModalImbalancedData
                key={nodeId}
                nodeId={nodeId}
                nodeName={nodeName}
                changeNodeName={changeNodeName}
                nodes={nodes}
                edges={edges}
                open={imbalancedDataOpen}
                setNodes={setNodes}
                handleClose={handleImbalancedDataClose}
              />
            )}

            {nodeName === 'Imbalanced Data Sampling' && nodes && (
              <NodeModalImbalancedDataSampling
                key={nodeId}
                nodeId={nodeId}
                nodeName={nodeName}
                changeNodeName={changeNodeName}
                nodes={nodes}
                edges={edges}
                open={imbalancedDataSamplingOpen}
                setNodes={setNodes}
                handleClose={handleImbalancedDataSamplingClose}
              />
            )}

            {nodeName === 'DataQualityIssues' && nodes && (
              <NodeModalDataQualityIssues
                key={nodeId}
                nodeId={nodeId}
                nodeName={nodeName}
                changeNodeName={changeNodeName}
                nodes={nodes}
                edges={edges}
                open={dataQualityIssuesOpen}
                setNodes={setNodes}
                handleClose={handleDataQualityIssuesClose}
              />
            )}
            {nodeName === 'DataQualityIssues2' && nodes && (
              <NodeModalDataQualityIssues2
                key={nodeId}
                nodeId={nodeId}
                nodeName={nodeName}
                changeNodeName={changeNodeName}
                nodes={nodes}
                edges={edges}
                open={dataQualityIssues2Open}
                setNodes={setNodes}
                handleClose={handleDataQualityIssues2Close}
              />
            )}

            {nodeName === 'DataProfiling' && nodes && (
              <NodeModalDataProfiling
                key={nodeId}
                nodeId={nodeId}
                nodeName={nodeName}
                changeNodeName={changeNodeName}
                nodes={nodes}
                edges={edges}
                open={dataProfilingOpen}
                setNodes={setNodes}
                handleClose={handleDataProfilingClose}
              />
            )}

            {nodeName === 'VisualInsights' && nodes && (
              <NodeModalVisualInsights
                key={nodeId}
                nodeId={nodeId}
                nodeName={nodeName}
                changeNodeName={changeNodeName}
                nodes={nodes}
                edges={edges}
                open={visualInsightsOpen}
                setNodes={setNodes}
                handleClose={handleVisualInsightsClose}
              />
            )}

            {nodeName === 'Drop' && nodes && (
              <NodeModalDrop
                key={nodeId}
                nodeId={nodeId}
                nodeName={nodeName}
                changeNodeName={changeNodeName}
                nodes={nodes}
                edges={edges}
                open={dropOpen}
                setNodes={setNodes}
                handleClose={handleDropClose}
              />
            )}

            {nodeName === 'Scaler' && nodes && (
              <NodeModalScaler
                key={nodeId}
                nodeId={nodeId}
                nodeName={nodeName}
                changeNodeName={changeNodeName}
                nodes={nodes}
                edges={edges}
                open={scalerOpen}
                setNodes={setNodes}
                handleClose={handleScalerClose}
              />
            )}

            {nodeName === 'Resample' && nodes && (
              <NodeModalResample
                key={nodeId}
                nodeId={nodeId}
                nodeName={nodeName}
                changeNodeName={changeNodeName}
                nodes={nodes}
                edges={edges}
                open={resampleOpen}
                setNodes={setNodes}
                handleClose={handleResampleClose}
              />
            )}

            {nodeName === 'Label Encoder' && nodes && (
              <NodeModalLabelEncoder
                key={nodeId}
                nodeId={nodeId}
                nodeName={nodeName}
                changeNodeName={changeNodeName}
                nodes={nodes}
                edges={edges}
                open={labelEncoderOpen}
                setNodes={setNodes}
                handleClose={handleLabelEncoderClose}
              />
            )}

            {nodeName === 'OpenSearch' && nodes && (
              <NodeModalOpenSearch
                key={nodeId}
                nodeId={nodeId}
                changeNodeName={changeNodeName}
                nodeName={nodeName}
                nodes={nodes}
                edges={edges}
                open={OpenSearchOpen}
                setNodes={setNodes}
                handleClose={handleOpenSearchClose}
              />
            )}

            {nodeName === 'WriteSFTP' && nodes && (
              <NodeModalWriteSFTP
                key={nodeId}
                nodeId={nodeId}
                changeNodeName={changeNodeName}
                nodeName={nodeName}
                nodes={nodes}
                edges={edges}
                open={WriteSFTPOpen}
                setNodes={setNodes}
                handleClose={handleWriteSFTPClose}
              />
            )}

            {nodeName === 'Postgres' && nodes && (
              <NodeModalDatabase
                key={nodeId}
                nodeId={nodeId}
                changeNodeName={changeNodeName}
                nodeName={nodeName}
                nodes={nodes}
                edges={edges}
                open={DatabaseOpen}
                setNodes={setNodes}
                handleClose={handleDatabaseClose}
              />
            )}
            {nodeName === 'C360' && nodes && (
              <NodeModalC360
                key={nodeId}
                nodeId={nodeId}
                changeNodeName={changeNodeName}
                nodeName={nodeName}
                nodes={nodes}
                edges={edges}
                open={C360Open}
                setNodes={setNodes}
                handleClose={handleC360Close}
              />
            )}
            {nodeName === 'ReadCSV' && nodes && (
              <NodeModalReadCSV
                key={nodeId}
                nodeId={nodeId}
                nodeName={nodeName}
                changeNodeName={changeNodeName}
                nodes={nodes}
                edges={edges}
                open={readCsvOpen}
                setNodes={setNodes}
                handleClose={handleReadCsvClose}
              />
            )}
            {nodeName === 'ReadCSVData' && nodes && (
              <NodeModalReadCSVData
                key={nodeId}
                nodeId={nodeId}
                nodeName={nodeName}
                changeNodeName={changeNodeName}
                nodes={nodes}
                edges={edges}
                open={readCsvDataOpen}
                setNodes={setNodes}
                handleClose={handleReadCsvDataClose}
              />
            )}
            {nodeName === 'ReadCSVAws' && nodes && (
              <NodeModalReadCSVAws
                key={nodeId}
                nodeId={nodeId}
                nodeName={nodeName}
                changeNodeName={changeNodeName}
                nodes={nodes}
                edges={edges}
                open={readCsvOpen2}
                setNodes={setNodes}
                handleClose={handleReadCsvClose2}
              />
            )}
            {nodeName === 'ReadCSVAzure' && nodes && (
              <NodeModalReadCSVAzure
                key={nodeId}
                nodeId={nodeId}
                nodeName={nodeName}
                changeNodeName={changeNodeName}
                nodes={nodes}
                edges={edges}
                open={readCsvAzureOpen}
                setNodes={setNodes}
                handleClose={handleReadCsvAzureClose}
              />
            )}
            {nodeName === 'ReadPostgres2' && nodes && (
              <NodeModalReadPostgres2
                key={nodeId}
                nodeId={nodeId}
                nodeName={nodeName}
                changeNodeName={changeNodeName}
                nodes={nodes}
                edges={edges}
                open={readPostgres2Open}
                setNodes={setNodes}
                handleClose={handleReadPostgres2Close}
              />
            )}
            {nodeName === 'ReadSnowflake2' && nodes && (
              <NodeModalReadSnowflake2
                key={nodeId}
                nodeId={nodeId}
                nodeName={nodeName}
                changeNodeName={changeNodeName}
                nodes={nodes}
                edges={edges}
                open={readSnowflake2Open}
                setNodes={setNodes}
                handleClose={handleReadSnowflake2Close}
              />
            )}
            {nodeName === 'ReadOracleDB' && nodes && (
              <NodeModalReadOracleDB
                key={nodeId}
                nodeId={nodeId}
                nodeName={nodeName}
                changeNodeName={changeNodeName}
                nodes={nodes}
                edges={edges}
                open={readOracleDBOpen}
                setNodes={setNodes}
                handleClose={handleReadOracleDBClose}
              />
            )}
            {nodeName === 'ReadSQLServer' && nodes && (
              <NodeModalReadSQLServer
                key={nodeId}
                nodeId={nodeId}
                nodeName={nodeName}
                changeNodeName={changeNodeName}
                nodes={nodes}
                edges={edges}
                open={ReadSQLServerOpen}
                setNodes={setNodes}
                handleClose={handleReadSQLServerClose}
              />
            )}
            {nodeName === 'AddColumn' && nodes && (
              <NodeModalAddColumn
                key={nodeId}
                nodeId={nodeId}
                nodeName={nodeName}
                changeNodeName={changeNodeName}
                nodes={nodes}
                edges={edges}
                open={addColumnOpen}
                setNodes={setNodes}
                handleClose={handleAddColumnClose}
                workflow={workflow}
              />
            )}
            {nodeName === 'DeleteColumn' && nodes && (
              <NodeModalDeleteColumn
                key={nodeId}
                nodeId={nodeId}
                nodeName={nodeName}
                changeNodeName={changeNodeName}
                nodes={nodes}
                edges={edges}
                open={deleteColumnOpen}
                setNodes={setNodes}
                handleClose={handleDeleteColumnClose}
                workflow={workflow}
              />
            )}
            {ModalComponent && (
              <ModalComponent
                key={nodeId}
                nodeId={nodeId}
                nodeName={nodeName}
                changeNodeName={changeNodeName}
                nodes={nodes}
                edges={edges}
                open={transformationOpen}
                setNodes={setNodes}
                handleClose={handleTransformationClose}
                workflow={workflow}
              />
            )}

            {nodeName === 'Visualization' && nodes && (
              <NodeModalVisualization
                key={nodeId}
                nodeId={nodeId}
                nodeName={nodeName}
                changeNodeName={changeNodeName}
                nodes={nodes}
                edges={edges}
                open={visualizationOpen}
                setNodes={setNodes}
                handleClose={handleVisualizationClose}
              />
            )}
            {nodeName === DATA_QUALITY_RULES.nodeModalTitle && nodes && (
              <NodeModalDataQualityRules
                key={nodeId}
                nodeId={nodeId}
                nodeName={nodeName}
                changeNodeName={changeNodeName}
                nodes={nodes}
                edges={edges}
                open={dataQualityRulesOpen}
                setNodes={setNodes}
                handleClose={handleDataQualityRulesClose}
              />
            )}
            {nodeName === DATA_QUALITY_RULES2.nodeModalTitle && nodes && (
              <NodeModalDataQualityRules2
                key={nodeId}
                nodeId={nodeId}
                nodeName={nodeName}
                changeNodeName={changeNodeName}
                nodes={nodes}
                edges={edges}
                open={dataQualityRules2Open}
                setNodes={setNodes}
                handleClose={handleDataQualityRules2Close}
              />
            )}
            {nodeName === DATA_QUALITY_REPORT.nodeModalTitle && nodes && (
              <NodeModalDataQualityReport
                key={nodeId}
                nodeId={nodeId}
                nodeName={nodeName}
                changeNodeName={changeNodeName}
                nodes={nodes}
                edges={edges}
                open={dataQualityReportOpen}
                setNodes={setNodes}
                handleClose={handleDataQualityReportClose}
              />
            )}
            {nodeName === 'PdfDataExtractor' && nodes && (
              <NodeModalPdfDataExtractor
                key={nodeId}
                nodeId={nodeId}
                nodeName={nodeName}
                changeNodeName={changeNodeName}
                nodes={nodes}
                edges={edges}
                open={pdfDataExtractorOpen}
                setNodes={setNodes}
                handleClose={handlePdfDataExtractorClose}
              />
            )}
            {nodeName === 'Rules Selector' && nodes && (
              <NodeModalRulesSelector
                key={nodeId}
                nodeId={nodeId}
                nodeName={nodeName}
                changeNodeName={changeNodeName}
                nodes={nodes}
                edges={edges}
                open={rulesSelectorOpen}
                setNodes={setNodes}
                handleClose={handleRulesSelectorClose}
              />
            )}
            {nodeName === 'AutomaticRuleGenerator' && nodes && (
              <NodeModalAutomaticRuleGenerator
                key={nodeId}
                nodeId={nodeId}
                nodeName={nodeName}
                changeNodeName={changeNodeName}
                nodes={nodes}
                edges={edges}
                open={automaticRuleGeneratorOpen}
                setNodes={setNodes}
                handleClose={handleAutomaticRuleGeneratorClose}
              />
            )}
            {nodeName === 'CopyDoc' && nodes && (
              <NodeModalCopyDoc
                key={nodeId}
                nodeId={nodeId}
                nodeName={nodeName}
                changeNodeName={changeNodeName}
                nodes={nodes}
                edges={edges}
                open={copyDocOpen}
                setNodes={setNodes}
                handleClose={handleCopyDocClose}
              />
            )}
            {nodeName === 'ReadPublishedData' && nodes && (
              <NodeModalReadPublishedData
                key={nodeId}
                nodeId={nodeId}
                nodeName={nodeName}
                changeNodeName={changeNodeName}
                nodes={nodes}
                edges={edges}
                open={readPublishedDataOpen}
                setNodes={setNodes}
                handleClose={handleReadPublishedDataClose}
              />
            )}
            {nodeName === 'FileUploader' && nodes && (
              <NodeModalFileUploader
                key={nodeId}
                nodeId={nodeId}
                nodeName={nodeName}
                changeNodeName={changeNodeName}
                nodes={nodes}
                edges={edges}
                open={FileUploaderOpen}
                setNodes={setNodes}
                handleClose={handleFileUploaderClose}
              />
            )}
            {nodeName === 'ReadStreaming' && nodes && (
              <NodeModalReadStreaming
                key={nodeId}
                nodeId={nodeId}
                nodeName={nodeName}
                changeNodeName={changeNodeName}
                nodes={nodes}
                edges={edges}
                open={readStreamingOpen}
                setNodes={setNodes}
                handleClose={handleReadStreamingClose}
              />
            )}
            {nodeName === 'ReadDelimited' && nodes && (
              <NodeModalReadDelimited
                key={nodeId}
                nodeId={nodeId}
                nodeName={nodeName}
                changeNodeName={changeNodeName}
                nodes={nodes}
                edges={edges}
                open={readDelimitedOpen}
                setNodes={setNodes}
                handleClose={handleReadDelimitedClose}
              />
            )}
            {nodeName === 'ReadOracle' && nodes && (
              <NodeModalReadOracle
                key={nodeId}
                nodeId={nodeId}
                nodeName={nodeName}
                changeNodeName={changeNodeName}
                nodes={nodes}
                edges={edges}
                open={readOraclepen}
                setNodes={setNodes}
                handleClose={handleReadOracleClose}
              />
            )}
            {nodeName === 'ReadPostgres' && nodes && (
              <NodeModalReadPostgres
                key={nodeId}
                nodeId={nodeId}
                nodeName={nodeName}
                changeNodeName={changeNodeName}
                nodes={nodes}
                edges={edges}
                open={readPostgresOpen}
                setNodes={setNodes}
                handleClose={handleReadPostgresClose}
              />
            )}
            {nodeName === FETCH_SCHEMA.nodeModalTitle && nodes && (
              <NodeModalFetchSchema
                key={nodeId}
                nodeId={nodeId}
                nodeName={nodeName}
                changeNodeName={changeNodeName}
                nodes={nodes}
                edges={edges}
                open={fetchSchemaOpen}
                setNodes={setNodes}
                handleClose={handleFetchSchemaClose}
              />
            )}
            {nodeName === 'ReadDB2' && nodes && (
              <NodeModalReadDB2
                key={nodeId}
                nodeId={nodeId}
                nodeName={nodeName}
                changeNodeName={changeNodeName}
                nodes={nodes}
                edges={edges}
                open={readDB2Open}
                setNodes={setNodes}
                handleClose={handleReadDB2Close}
              />
            )}
            {nodeName === 'ReadAuroraDB' && nodes && (
              <NodeModalReadAuroraDB
                key={nodeId}
                nodeId={nodeId}
                nodeName={nodeName}
                changeNodeName={changeNodeName}
                nodes={nodes}
                edges={edges}
                open={readAuroraDBOpen}
                setNodes={setNodes}
                handleClose={handleReadAuroraDBClose}
              />
            )}
            {nodeName === 'ReadCosmos' && nodes && (
              <NodeModalReadCosmos
                key={nodeId}
                nodeId={nodeId}
                nodeName={nodeName}
                changeNodeName={changeNodeName}
                nodes={nodes}
                edges={edges}
                open={readCosmosOpen}
                setNodes={setNodes}
                handleClose={handleReadCosmosClose}
              />
            )}
            {nodeName === 'ReadApi' && nodes && (
              <NodeModalReadAPI
                key={nodeId}
                nodeId={nodeId}
                nodeName={nodeName}
                changeNodeName={changeNodeName}
                nodes={nodes}
                edges={edges}
                open={readApiOpen}
                setNodes={setNodes}
                handleClose={handleReadApiClose}
              />
            )}
            {nodeName === 'ReadMySql' && nodes && (
              <NodeModalReadMySql
                key={nodeId}
                nodeId={nodeId}
                nodeName={nodeName}
                changeNodeName={changeNodeName}
                nodes={nodes}
                edges={edges}
                open={readMySqlOpen}
                setNodes={setNodes}
                handleClose={handleReadMySqlClose}
              />
            )}

            {nodeName === 'ReadSnowflake' && nodes && (
              <NodeModalReadSnowflake
                key={nodeId}
                nodeId={nodeId}
                nodeName={nodeName}
                changeNodeName={changeNodeName}
                nodes={nodes}
                edges={edges}
                open={readSnowflakeOpen}
                setNodes={setNodes}
                handleClose={handleReadSnowflakeClose}
              />
            )}
            {nodeName === 'Read Real-Time' && nodes && (
              <NodeModalReadRealTime
                key={nodeId}
                nodeId={nodeId}
                nodeName={nodeName}
                changeNodeName={changeNodeName}
                nodes={nodes}
                edges={edges}
                open={readRealTimeOpen}
                setNodes={setNodes}
                handleClose={handleReadRealTimeClose}
              />
            )}

            {nodeName === 'Execute SQL' && nodes && (
              <NodeModalExecuteSql
                key={nodeId}
                nodeId={nodeId}
                nodeName={nodeName}
                changeNodeName={changeNodeName}
                nodes={nodes}
                edges={edges}
                open={sqlOpen}
                setNodes={setNodes}
                handleClose={handleSqlClose}
              />
            )}
            {nodeName === LLM_MAPPER.nodeModalTitle && nodes && (
              <NodeModalLlmMapper
                key={nodeId}
                nodeId={nodeId}
                nodeName={nodeName}
                changeNodeName={changeNodeName}
                nodes={nodes}
                edges={edges}
                open={llmMapperOpen}
                setNodes={setNodes}
                handleClose={handleLlmMapperClose}
              />
            )}

            {nodeName === LLM_MAPPER_V2.nodeModalTitle && nodes && (
              <NodeModalAutoMapperV2
                key={nodeId}
                nodeId={nodeId}
                nodeName={nodeName}
                changeNodeName={changeNodeName}
                nodes={nodes}
                edges={edges}
                open={llmMapperV2Open}
                setNodes={setNodes}
                handleClose={handleLlmMapperV2Close}
              />
            )}

            {nodeName === LLM_DQ_RULES.nodeModalTitle && nodes && (
              <NodeModalLLMDQRules
                key={nodeId}
                nodeId={nodeId}
                nodeName={nodeName}
                changeNodeName={changeNodeName}
                nodes={nodes}
                edges={edges}
                open={llmDqRuleOpen}
                setNodes={setNodes}
                handleClose={handleLlmDqRuleClose}
              />
            )}
            {nodeName === LLM_DQ_RULES_2.nodeModalTitle && nodes && (
              <NodeModalLLMDQRules2
                key={nodeId}
                nodeId={nodeId}
                nodeName={nodeName}
                changeNodeName={changeNodeName}
                nodes={nodes}
                edges={edges}
                open={llmDqRuleOpen}
                setNodes={setNodes}
                handleClose={handleLlmDqRuleClose}
              />
            )}
            {nodeName === PE_INSIGHTS_MAPPER.nodeModalTitle && nodes && (
              <NodeModalPEInsightsMapper
                key={nodeId}
                nodeId={nodeId}
                nodeName={nodeName}
                changeNodeName={changeNodeName}
                nodes={nodes}
                edges={edges}
                open={pEInsightsMapperOpen}
                setNodes={setNodes}
                handleClose={handlePEInsightsMapperClose}
              />
            )}
            {nodeName === PE_DATA_REPORT.nodeModalTitle && nodes && (
              <NodeModalPEDataReport
                key={nodeId}
                nodeId={nodeId}
                nodeName={nodeName}
                changeNodeName={changeNodeName}
                nodes={nodes}
                edges={edges}
                open={pEDataReportOpen}
                setNodes={setNodes}
                handleClose={handlePEDataReportClose}
              />
            )}

            {nodeName === 'KPI' && nodes && (
              <NodeModalKPI
                key={nodeId}
                nodeId={nodeId}
                nodeName={nodeName}
                changeNodeName={changeNodeName}
                nodes={nodes}
                edges={edges}
                open={KPIOpen}
                setNodes={setNodes}
                handleClose={handleKPIClose}
              />
            )}

            {nodeName === 'SnowFlake' && nodes && (
              <NodeModalSnowFlake
                key={nodeId}
                nodeId={nodeId}
                changeNodeName={changeNodeName}
                nodeName={nodeName}
                nodes={nodes}
                edges={edges}
                open={SnowFlakeOpen}
                setNodes={setNodes}
                handleClose={handleSnowFlakeClose}
              />
            )}

            {nodeName === 'Udf' && nodes && (
              <NodeModalUdf
                key={nodeId}
                nodeId={nodeId}
                nodeName={nodeName}
                changeNodeName={changeNodeName}
                nodes={nodes}
                edges={edges}
                open={udfOpen}
                setNodes={setNodes}
                handleClose={handleUdfClose}
              />
            )}

            {nodeName === 'Join' && nodes && (
              <NodeModalJoin
                key={nodeId}
                nodeId={nodeId}
                nodeName={nodeName}
                changeNodeName={changeNodeName}
                nodes={nodes}
                edges={edges}
                open={joinOpen}
                setNodes={setNodes}
                handleClose={handleJoinClose}
              />
            )}

            {nodeName === 'Sort' && nodes && (
              <NodePropertiesSort
                key={nodeId}
                nodeId={nodeId}
                nodeName={nodeName}
                changeNodeName={changeNodeName}
                nodes={nodes}
                edges={edges}
                open={sortOpen}
                setNodes={setNodes}
                handleClose={handleSortClose}
              />
            )}

            {nodeName === 'Coalesce' && nodes && (
              <NodeModalCoalease
                key={nodeId}
                nodeId={nodeId}
                nodeName={nodeName}
                changeNodeName={changeNodeName}
                nodes={nodes}
                edges={edges}
                open={coaleaseOpen}
                setNodes={setNodes}
                handleClose={handleCoaleaseClose}
              />
            )}

            {nodeName === 'Filter' && nodes && (
              <NodePropertiesFilter
                key={nodeId}
                nodeId={nodeId}
                nodeName={nodeName}
                changeNodeName={changeNodeName}
                nodes={nodes}
                edges={edges}
                open={filterOpen}
                setNodes={setNodes}
                handleClose={handleFilterClose}
              />
            )}
            {nodeName === 'Union' && nodes && (
              <NodeModalUnion
                key={nodeId}
                nodeId={nodeId}
                nodeName={nodeName}
                changeNodeName={changeNodeName}
                nodes={nodes}
                edges={edges}
                open={unionOpen}
                setNodes={setNodes}
                handleClose={handleUnionClose}
              />
            )}

            {nodeName === 'Email' && nodes && (
              <NodeModalEmail
                key={nodeId}
                nodeId={nodeId}
                nodeName={nodeName}
                changeNodeName={changeNodeName}
                nodes={nodes}
                edges={edges}
                open={emailOpen}
                setNodes={setNodes}
                handleClose={handleEmailClose}
              />
            )}

            {nodeName === 'Data Cleansing' && nodes && (
              <NodeModalDataCleansing
                key={nodeId}
                nodeId={nodeId}
                nodeName={nodeName}
                changeNodeName={changeNodeName}
                nodes={nodes}
                edges={edges}
                open={cleansingOpen}
                setNodes={setNodes}
                handleClose={handleCleansingClose}
              />
            )}
            {nodeName === DATA_QUALITY_AGENT.nodeModalTitle && nodes && (
              <NodeModalDataQualityAgent
                key={nodeId}
                nodeId={nodeId}
                nodeName={nodeName}
                changeNodeName={changeNodeName}
                nodes={nodes}
                edges={edges}
                open={modalStates[nodeName]}
                setNodes={setNodes}
                handleClose={() => closeModal(nodeName)}
              />
            )}
            {nodeName === DEDUPLICATION_AGENT.nodeModalTitle && nodes && (
              <NodeModalDeduplicationAgent
                key={nodeId}
                nodeId={nodeId}
                nodeName={nodeName}
                changeNodeName={changeNodeName}
                nodes={nodes}
                edges={edges}
                open={modalStates[nodeName]}
                setNodes={setNodes}
                handleClose={() => closeModal(nodeName)}
              />
            )}

            {nodeName === 'Aggregation' && nodes && (
              <NodeModalAggregate
                key={nodeId}
                nodeId={nodeId}
                nodeName={nodeName}
                changeNodeName={changeNodeName}
                nodes={nodes}
                edges={edges}
                open={aggregateOpen}
                setNodes={setNodes}
                handleClose={handleAggregateClose}
              />
            )}

            {nodeName === 'Ingestion Write' && nodes && (
              <NodeModalIngestionWrite
                key={nodeId}
                nodeId={nodeId}
                nodeName={nodeName}
                changeNodeName={changeNodeName}
                nodes={nodes}
                edges={edges}
                open={ingestionWriteOpen}
                setNodes={setNodes}
                handleClose={handleIngestionWriteClose}
              />
            )}
            {nodeName === 'FlatUnion' && nodes && (
              <NodeModalFlatUnion
                key={nodeId}
                nodeId={nodeId}
                nodeName={nodeName}
                changeNodeName={changeNodeName}
                nodes={nodes}
                edges={edges}
                open={flatUnionOpen}
                setNodes={setNodes}
                handleClose={handleFlatUnionClose}
              />
            )}
            {nodeName === 'Training' && nodes && (
              <NodePropertiesTraining
                key={nodeId}
                nodeId={nodeId}
                nodeName={nodeName}
                changeNodeName={changeNodeName}
                nodes={nodes}
                edges={edges}
                open={trainingOpen}
                setNodes={setNodes}
                handleClose={handleTrainingClose}
              />
            )}
            {nodeName === 'Prediction' && nodes && (
              <NodePropertiesPrediction
                key={nodeId}
                nodeId={nodeId}
                nodeName={nodeName}
                changeNodeName={changeNodeName}
                nodes={nodes}
                edges={edges}
                open={predictionOpen}
                setNodes={setNodes}
                handleClose={handlePredictionClose}
              />
            )}
            {nodeName === 'Profiling' && nodes && (
              <NodeModalProfiling
                key={nodeId}
                nodeId={nodeId}
                nodeName={nodeName}
                changeNodeName={changeNodeName}
                nodes={nodes}
                edges={edges}
                open={profilingOpen}
                setNodes={setNodes}
                handleClose={handleProfilingClose}
              />
            )}
            {nodeName === 'Math Transformation' && nodes && (
              <NodeModalMathTransformation
                key={nodeId}
                nodeId={nodeId}
                nodeName={nodeName}
                changeNodeName={changeNodeName}
                nodes={nodes}
                edges={edges}
                open={mathTransformationOpen}
                setNodes={setNodes}
                handleClose={handleMathTransformationClose}
              />
            )}
            {nodeName === 'DataValidation' && nodes && (
              <NodeModalDataValidation
                key={nodeId}
                nodeId={nodeId}
                nodeName={nodeName}
                changeNodeName={changeNodeName}
                nodes={nodes}
                edges={edges}
                open={dataValidationOpen}
                setNodes={setNodes}
                handleClose={handleDataValidationClose}
              />
            )}
            {nodeName === 'WriteAzure' && nodes && (
              <NodeModalWriteAzure
                key={nodeId}
                nodeId={nodeId}
                changeNodeName={changeNodeName}
                nodeName={nodeName}
                nodes={nodes}
                edges={edges}
                open={WriteAzureOpen}
                setNodes={setNodes}
                handleClose={handleWriteAzureClose}
              />
            )}
            {nodeName === 'WriteCsvAWS' && nodes && (
              <NodeModalWriteCsvAWS
                key={nodeId}
                nodeId={nodeId}
                changeNodeName={changeNodeName}
                nodeName={nodeName}
                nodes={nodes}
                edges={edges}
                open={writeCsvAWSOpen}
                setNodes={setNodes}
                handleClose={handleWriteCsvAWSClose}
              />
            )}
            {nodeName === 'WritePostgres' && nodes && (
              <NodeModalWritePostgres
                key={nodeId}
                nodeId={nodeId}
                changeNodeName={changeNodeName}
                nodeName={nodeName}
                nodes={nodes}
                edges={edges}
                open={writePostgresOpen}
                setNodes={setNodes}
                handleClose={handleWritePostgresClose}
              />
            )}

            {nodeName === 'WriteSnowflake' && nodes && (
              <NodeModalWriteSnowflake
                key={nodeId}
                nodeId={nodeId}
                changeNodeName={changeNodeName}
                nodeName={nodeName}
                nodes={nodes}
                edges={edges}
                open={writeSnowflakeOpen}
                setNodes={setNodes}
                handleClose={handleWriteSnowflakeClose}
              />
            )}
            {nodeName === 'WriteOracleDB' && nodes && (
              <NodeModalWriteOracleDB
                key={nodeId}
                nodeId={nodeId}
                changeNodeName={changeNodeName}
                nodeName={nodeName}
                nodes={nodes}
                edges={edges}
                open={writeOracleDBOpen}
                setNodes={setNodes}
                handleClose={handleWriteOracleDBClose}
              />
            )}
            {nodeName === 'WriteSqlServer' && nodes && (
              <NodeModalWriteSqlServer
                key={nodeId}
                nodeId={nodeId}
                changeNodeName={changeNodeName}
                nodeName={nodeName}
                nodes={nodes}
                edges={edges}
                open={writeSqlServerOpen}
                setNodes={setNodes}
                handleClose={handleWriteSqlServerClose}
              />
            )}
            {nodeName === 'Data Cleaning & Validation' && nodes && (
              <NodeModalRuleEngine
                key={nodeId}
                nodeId={nodeId}
                nodeName={nodeName}
                changeNodeName={changeNodeName}
                nodes={nodes}
                edges={edges}
                open={ruleEngineOpen}
                setNodes={setNodes}
                handleClose={handleRuleEngineClose}
              />
            )}
            {nodeName === 'Fuzzy Match' && nodes && (
              <NodeModalFuzzyMatch
                key={nodeId}
                nodeId={nodeId}
                nodeName={nodeName}
                changeNodeName={changeNodeName}
                nodes={nodes}
                edges={edges}
                open={fuzzyMatchOpen}
                setNodes={setNodes}
                handleClose={handleFuzzyMatchClose}
              />
            )}
            {nodeName === 'Match & Merge' && nodes && (
              <NodeModalManualMerge
                key={nodeId}
                nodeId={nodeId}
                nodeName={nodeName}
                changeNodeName={changeNodeName}
                nodes={nodes}
                edges={edges}
                open={manualMergeOpen}
                setNodes={setNodes}
                handleClose={handleManualMergeClose}
              />
            )}
            {nodeName === 'Customer Segmentation' && nodes && (
              <NodeModalCustomerSegmentation
                key={nodeId}
                nodeId={nodeId}
                nodeName={nodeName}
                changeNodeName={changeNodeName}
                nodes={nodes}
                edges={edges}
                open={custSegmentationOpen}
                setNodes={setNodes}
                handleClose={handleCustSegmentationClose}
              />
            )}
            {nodeName === 'Segment' && nodes && (
              <NodeModalSegmentation
                key={nodeId}
                nodeId={nodeId}
                nodeName={nodeName}
                changeNodeName={changeNodeName}
                nodes={nodes}
                edges={edges}
                open={segmentationOpen}
                setNodes={setNodes}
                handleClose={handleSegmentationClose}
              />
            )}
            {nodeName === 'Dedupe' && nodes && (
              <NodeModalCluster
                key={nodeId}
                nodeId={nodeId}
                nodeName={nodeName}
                changeNodeName={changeNodeName}
                nodes={nodes}
                edges={edges}
                open={clusterOpen}
                setNodes={setNodes}
                handleClose={handleClusterClose}
              />
            )}
            {nodeName === 'Plot' && nodes && (
              <NodeModalPlot
                key={nodeId}
                nodeId={nodeId}
                nodeName={nodeName}
                changeNodeName={changeNodeName}
                nodes={nodes}
                edges={edges}
                open={plotOpen}
                setNodes={setNodes}
                handleClose={handlePlotClose}
              />
            )}
            {nodeName === 'Analysis' && nodes && (
              <NodeModalAnalysis
                key={nodeId}
                nodeId={nodeId}
                nodeName={nodeName}
                changeNodeName={changeNodeName}
                nodes={nodes}
                edges={edges}
                open={analysisOpen}
                setNodes={setNodes}
                handleClose={handleAnalysisClose}
              />
            )}
            {nodeName === 'RFM' && nodes && (
              <NodeModalRFM
                key={nodeId}
                nodeId={nodeId}
                nodeName={nodeName}
                changeNodeName={changeNodeName}
                nodes={nodes}
                edges={edges}
                open={rfmOpen}
                setNodes={setNodes}
                handleClose={handleRfmClose}
              />
            )}
            <style>
              {`
          @keyframes rotate-clockwise {
            0% {
              transform: rotate(0deg);
            }
            100% {
              transform: rotate(360deg);
            }
          }
          .rotate {
            animation: rotate-clockwise 1s linear;
          }
        `}
            </style>
            <div className="reactflow-wrapper" ref={reactFlowWrapper}>
              {workflow.process_type !== MAIN.xperience360 && workflow.process_type !== 'Customer Segmentation' && (
                <>
                  <Tooltip title="Copilot">
                    <Fab
                      aria-label="etl-copilot"
                      onClick={() => {
                        setWorkflow({
                          ...workflow,
                          copilotOpen: !workflow.copilotOpen,
                        });
                      }}
                      size="medium"
                      sx={{
                        position: 'absolute',
                        bottom: 14,
                        right: 25,
                        background: '#fff',
                        // border:'1px solid green',
                        // background: '#DCFCE7',
                        // border: workflow.copilotOpen ? '2px solid #4880EC' : '',
                        boxShadow: workflow.copilotOpen ? '0 2px 4px #4880EC' : '0 2px 4px rgba(0, 0, 0, 0.1)', // fallback/default
                      }}
                    >
                      <img
                        src={ETL_COPILOT.LOGO} // 🔁 Replace with actual image path
                        alt="Copilot"
                        style={{
                          width: 30,
                          height: 30,
                          objectFit: 'contain',
                        }}
                      />
                    </Fab>
                  </Tooltip>
                  <Tooltip title="Refresh Status">
                    <Fab
                      aria-label="data-lineage"
                      onClick={handleRefreshStatus}
                      size="small"
                      sx={{ position: 'absolute', top: 14, right: 125, background: '#fff' }}
                    >
                      <RefreshIcon fontSize="medium" color="primary" className={isRotating ? 'rotate' : ''} />
                    </Fab>
                  </Tooltip>

                  <Tooltip title={`${runExecutionStatus ? 'Pause' : 'Play'} Execution Status`}>
                    <Fab
                      aria-label="data-lineage"
                      onClick={handleExecutionStatus}
                      size="small"
                      sx={{ position: 'absolute', top: 14, right: 75, background: '#fff' }}
                    >
                      {runExecutionStatus ? (
                        <PauseIcon fontSize="medium" color="primary" />
                      ) : (
                        <UpdateIcon fontSize="medium" color="primary" />
                      )}
                    </Fab>
                  </Tooltip>

                  <Tooltip title="Data Lineage">
                    <Fab
                      aria-label="data-lineaege"
                      onClick={handleDataLineage}
                      size="small"
                      sx={{ position: 'absolute', top: 14, right: 25, background: '#fff' }}
                    >
                      <LinearScaleIcon fontSize="medium" color="primary" />
                    </Fab>
                  </Tooltip>
                </>
              )}
              <ReactFlow
                id="react-flow-panel"
                nodes={nodes}
                edges={edges}
                onNodeClick={onNodeClick}
                onNodesChange={onNodesChange}
                onEdgesChange={onEdgesChange}
                onEdgeUpdate={onEdgeUpdate}
                onConnect={onConnect}
                onInit={setReactFlowInstance}
                onDrop={onDrop}
                fitView
                onDragOver={onDragOver}
                nodeTypes={nodeTypes}
                edgeTypes={edgeTypes}
                attributionPosition="bottom-left"
                proOptions={proOptions}
              >
                {/* <Controls position="top-left" /> */}
                <Controls position="top-left">
                  <ControlButton onClick={handleLabelVisible} title="label visibility">
                    {isLabelVisible ? <MdLabel /> : <MdLabelOff />}
                  </ControlButton>
                </Controls>
                <Background variant="cross" />
                {/* <CustomBackground gap={100} text="X360" fontSize={18} /> */}
              </ReactFlow>
            </div>
          </ReactFlowProvider>
          <DataLineageGraph open={isDataLineage} handleClose={handleDataLineage} />
        </div>
      </Paper>
    </>
  );
});

export default ReactFlowPannel;
